// import React, { useState, useEffect } from 'react';
// import { jwtDecode } from 'jwt-decode';
// import { URL } from '../../../config';
// import './userprofile.css';
// import { Pagination } from 'react-bootstrap';

// const OrderHistory = ({ onManageClick }) => {
//   const [orders, setOrders] = useState([]);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 5;

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith('user-') ? userId.split('user-')[1] : userId;
//           const response = await fetch(`${URL}/user/${extractedUserId}/orders`);
//           if (response.ok) {
//             const orderData = await response.json();
//             // if order is cancelled by user that data will not show but admin can view
//             const filteredOrders = orderData.filter(order => order.status !== 'Cancelled');
//             setOrders(filteredOrders);
//           } else {
//             setError('Failed to fetch orders');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching order history:', error);
//         setError('An error occurred while fetching order history');
//       }
//     };

//     fetchOrders();
//   }, []);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(orders.length / ordersPerPage);

//   return (
//     <div className="order-history">
//       <h2>Order History</h2>
//       {error && <p className="error-message">{error}</p>}
//       {orders.length > 0 ? (
//         <>
//           <table className="order-table">
//             <thead>
//               <tr>
//                 <th>Order#</th>
//                 <th>Placed on</th>
//                 <th>Service</th>
//                 <th>Order details</th>
//                 <th>Status</th>
//                 <th>Total</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.map((order) => (
//                 <tr key={order.order_number}>
//                   <td>{order.order_number}</td>
//                   <td>{new Date(order.created_at).toLocaleDateString()}</td>
//                   <td>
//                     {order.Service ? order.Service.services_name : "Unknown"}
//                   </td>
//                   {/* <td>
//                     {order.bed !== undefined ? (
//                       <>
//                         <div>Bedroom: {order.bed}, Bathroom: {order.bath}, Drawing-Dinning: {order.dra_din}</div>
//                         <div>Kitchen: {order.kitchen}, Cloths: {order.cloth}, Dishes: {order.dish}</div>
//                       </>
//                     ) : order.Fan_in_un !== undefined ? (
//                       <>
//                         <div>Fan Install: {order.Fan_in_un}, Light Install: {order.Light_in_un}, Fan Repair: {order.Fan_repair}, Light Repair: {order.Light_repair}</div>
//                         <div>Switch Repair: {order.Switch_repair}, MCB Service: {order.MCB_service}, MDB Service: {order.MDB_service}</div>
//                       </>
//                     ) : (
//                       <>
//                         <div>Toilet Install: {order.Toilet_in}, Faucet Install: {order.Faucet_in}, Sink Install: {order.Sink_in}, Dishwasher Install: {order.Dishwasher_in}</div>
//                         <div>Leak Repair: {order.Leak_repair}, Faucet Repair: {order.Faucet_repair}, Toilet Repair: {order.Toilet_repair}, Shower Repair: {order.Shower_repair}, Drain Clean: {order.Drain_cleaning}</div>
//                       </>
//                     )}
//                   </td> */}
//                   <td>
//                     {order.service_name === "Home Cleaning" ? (
//                       <>
//                         <div>
//                           Bedroom: {order.bed}, Bathroom: {order.bath},
//                           Drawing-Dinning: {order.dra_din}
//                         </div>
//                         <div>
//                           Kitchen: {order.kitchen}, Cloths: {order.cloth},
//                           Dishes: {order.dish}
//                         </div>
//                       </>
//                     ) : order.service_name === "Electrician" ? (
//                       <>
//                         <div>
//                           Fan Install: {order.Fan_in_un}, Light Install:{" "}
//                           {order.Light_in_un}, Fan Repair: {order.Fan_repair},
//                           Light Repair: {order.Light_repair}
//                         </div>
//                         <div>
//                           Switch Repair: {order.Switch_repair}, MCB Service:{" "}
//                           {order.MCB_service}, MDB Service: {order.MDB_service}
//                         </div>
//                       </>
//                     ) : order.service_name === "Plumber" ? (
//                       <>
//                         <div>
//                           Toilet Install: {order.Toilet_in}, Faucet Install:{" "}
//                           {order.Faucet_in}, Sink Install: {order.Sink_in},
//                           Dishwasher Install: {order.Dishwasher_in}
//                         </div>
//                         <div>
//                           Leak Repair: {order.Leak_repair}, Faucet Repair:{" "}
//                           {order.Faucet_repair}, Toilet Repair:{" "}
//                           {order.Toilet_repair}, Shower Repair:{" "}
//                           {order.Shower_repair}, Drain Clean:{" "}
//                           {order.Drain_cleaning}
//                         </div>
//                       </>
//                     ) : (
//                       <div>Unknown service details</div>
//                     )}
//                   </td>
//                   <td>{order.status}</td>
//                   <td>{order.price} tk</td>
//                   <td>
//                     <button
//                       className="manage-button"
//                       onClick={() => onManageClick(order)}
//                     >
//                       Manage
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <div className="pagination-container">
//             <Pagination>
//               <Pagination.First
//                 onClick={() => handlePageChange(1)}
//                 disabled={currentPage === 1}
//               />
//               <Pagination.Prev
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//               />
//               {[...Array(totalPages)].map((_, index) => (
//                 <Pagination.Item
//                   key={index + 1}
//                   active={index + 1 === currentPage}
//                   onClick={() => handlePageChange(index + 1)}
//                 >
//                   {index + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//               />
//               <Pagination.Last
//                 onClick={() => handlePageChange(totalPages)}
//                 disabled={currentPage === totalPages}
//               />
//             </Pagination>
//           </div>
//         </>
//       ) : (
//         <p>No orders yet!</p>
//       )}
//     </div>
//   );
// };

// export default OrderHistory;

//************** OrderHistor ************//

// import React, { useState, useEffect } from 'react';
// import { jwtDecode } from 'jwt-decode';
// import { FaFilter, FaDownload, FaPlus } from 'react-icons/fa';
// import { Container, Button, Card, Table } from 'reactstrap';
// import { Pagination } from 'react-bootstrap';
// import { URL } from '../../../config';

// const OrderHistory = ({ onManageClick }) => {
//   const [orders, setOrders] = useState([]);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 5;

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith('user-')
//             ? userId.split('user-')[1]
//             : userId;

//           const response = await fetch(`${URL}/user/${extractedUserId}/orders`);
//           if (response.ok) {
//             const orderData = await response.json();
//             // Filter out any orders that have been cancelled by user
//             const filteredOrders = orderData.filter(
//               (order) => order.status !== 'Cancelled'
//             );
//             setOrders(filteredOrders);
//           } else {
//             setError('Failed to fetch orders');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching order history:', error);
//         setError('An error occurred while fetching order history');
//       }
//     };

//     fetchOrders();
//   }, []);

//   // Pagination logic
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(orders.length / ordersPerPage);

//   // ---------- Countdown Timer ----------
//   const CountdownTimer = ({ dueDate, status }) => {
//     const [timeLeft, setTimeLeft] = useState({});
//     const [isExpired, setIsExpired] = useState(false);

//     useEffect(() => {
//       if (!dueDate || status === 'Completed') return;

//       const targetDate = new Date(dueDate).getTime();

//       const calculateTimeLeft = () => {
//         const now = new Date().getTime();
//         const difference = targetDate - now;

//         if (difference <= 0) {
//           setIsExpired(true);
//           return {
//             days: 0,
//             hours: 0,
//             minutes: 0,
//             seconds: 0,
//           };
//         }

//         return {
//           days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//           hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
//           minutes: Math.floor((difference / 1000 / 60) % 60),
//           seconds: Math.floor((difference / 1000) % 60),
//         };
//       };

//       // Initialize
//       setTimeLeft(calculateTimeLeft());

//       // Update every second
//       const timer = setInterval(() => {
//         setTimeLeft(calculateTimeLeft());
//       }, 1000);

//       // Cleanup
//       return () => clearInterval(timer);
//     }, [dueDate, status]);

//     if (status === 'Completed') {
//       return (
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//           <span style={{ fontSize: '12px', color: '#6c757d' }}>
//             Order completed
//           </span>
//         </div>
//       );
//     }

//     if (!dueDate) {
//       // If no dueDate is provided, show a placeholder
//       return (
//         <div style={{ fontSize: '13px', fontWeight: '500', color: '#6c757d' }}>
//           N/A
//         </div>
//       );
//     }

//     if (isExpired) {
//       return (
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//           <span style={{ fontSize: '12px', color: '#6c757d' }}>Due date</span>
//           <span style={{ color: '#e74c3c', fontWeight: '600' }}>Expired</span>
//         </div>
//       );
//     }

//     // Determine urgency color
//     let difference = new Date(dueDate).getTime() - new Date().getTime();
//     let hoursLeft = difference / (1000 * 60 * 60);
//     let countdownColor = '#4361ee'; // normal (primary)
//     if (hoursLeft < 6) countdownColor = '#e74c3c'; // urgent
//     else if (hoursLeft < 24) countdownColor = '#f39c12'; // warning

//     return (
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//         <span style={{ fontSize: '12px', color: '#6c757d' }}>
//           Time remaining
//         </span>
//         <div
//           style={{
//             display: 'flex',
//             flexWrap: 'wrap',
//             gap: '6px',
//             fontSize: '13px',
//             fontWeight: '500',
//           }}
//         >
//           {timeLeft.days > 0 && (
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//               <span style={{ fontWeight: '600', color: countdownColor }}>
//                 {timeLeft.days}
//               </span>
//               <span style={{ fontSize: '12px', color: '#6c757d' }}>
//                 &nbsp;day{timeLeft.days !== 1 ? 's' : ''}&nbsp;
//               </span>
//             </div>
//           )}
//           <div style={{ display: 'flex', alignItems: 'center' }}>
//             <span style={{ fontWeight: '600', color: countdownColor }}>
//               {timeLeft.hours}
//             </span>
//             <span style={{ fontSize: '12px', color: '#6c757d' }}>
//               &nbsp;hr&nbsp;
//             </span>
//           </div>
//           <div style={{ display: 'flex', alignItems: 'center' }}>
//             <span style={{ fontWeight: '600', color: countdownColor }}>
//               {timeLeft.minutes}
//             </span>
//             <span style={{ fontSize: '12px', color: '#6c757d' }}>
//               &nbsp;min&nbsp;
//             </span>
//           </div>
//           <div style={{ display: 'flex', alignItems: 'center' }}>
//             <span style={{ fontWeight: '600', color: countdownColor }}>
//               {timeLeft.seconds}
//             </span>
//             <span style={{ fontSize: '12px', color: '#6c757d' }}>
//               &nbsp;sec
//             </span>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ---------- Service Badge ----------
//   const ServiceBadge = ({ service }) => {
//     let badgeStyle = {
//       display: 'inline-block',
//       padding: '5px 10px',
//       borderRadius: '20px',
//       fontSize: '12px',
//       fontWeight: '500',
//       textAlign: 'center',
//     };
//     if (service === 'Home Cleaning') {
//       badgeStyle.backgroundColor = '#ebf5ff';
//       badgeStyle.color = '#2b6cb0';
//     } else if (service === 'Plumber') {
//       badgeStyle.backgroundColor = '#e6fffa';
//       badgeStyle.color = '#2c7a7b';
//     } else if (service === 'Electrician') {
//       badgeStyle.backgroundColor = '#fef3c7';
//       badgeStyle.color = '#92400e';
//     } else {
//       badgeStyle.backgroundColor = '#ebf5ff';
//       badgeStyle.color = '#2b6cb0';
//     }
//     return <span style={badgeStyle}>{service}</span>;
//   };

//   // ---------- Status Badge ----------
//   const StatusBadge = ({ status }) => {
//     const baseStyle = {
//       padding: '6px 12px',
//       borderRadius: '20px',
//       fontSize: '13px',
//       fontWeight: '500',
//       textAlign: 'center',
//     };

//     let backgroundColor = '#e6f7ff';
//     let color = '#0958d9';

//     if (status.toLowerCase() === 'completed') {
//       backgroundColor = '#d9f7be';
//       color = '#389e0d';
//     } else if (status.toLowerCase() === 'accepted') {
//       backgroundColor = '#e6f7ff';
//       color = '#0958d9';
//     } else if (status.toLowerCase() === 'pending') {
//       backgroundColor = '#fff3cd';
//       color = '#856404';
//     } else if (status.toLowerCase() === 'rejected') {
//       backgroundColor = '#f8d7da';
//       color = '#721c24';
//     }

//     return (
//       <span style={{ ...baseStyle, backgroundColor, color }}>{status}</span>
//     );
//   };

//   // ---------- Render Order Details ----------
//   const OrderDetails = ({ order }) => {
//     const { service_name } = order;
//     const textStyle = {
//       backgroundColor: "#f8f9fa",
//       padding: "4px 8px",
//       borderRadius: "4px",
//       fontSize: "12px",
//       color: "#495057",
//       marginRight: "8px",
//       marginBottom: "8px",
//       display: "inline-block",
//     };

//     // Helper to show a field only if it's non-zero
//     const renderChip = (label, value) => {
//       if (!value || Number(value) === 0) {
//         return null; // skip if 0 or falsy
//       }
//       return (
//         <span style={textStyle}>
//           {label}: {value}
//         </span>
//       );
//     };

//     if (service_name === "Home Cleaning") {
//       return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <div>
//             {renderChip("Bedroom", order.bed)}
//             {renderChip("Bathroom", order.bath)}
//             {renderChip("Drawing-Dinning", order.dra_din)}
//           </div>
//           <div>
//             {renderChip("Kitchen", order.kitchen)}
//             {renderChip("Cloths", order.cloth)}
//             {renderChip("Dishes", order.dish)}
//           </div>
//         </div>
//       );
//     } else if (service_name === "Plumber") {
//       return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <div>
//             {renderChip("Toilet Install", order.Toilet_in)}
//             {renderChip("Faucet Install", order.Faucet_in)}
//             {renderChip("Sink Install", order.Sink_in)}
//             {renderChip("Dishwasher Install", order.Dishwasher_in)}
//           </div>
//           <div>
//             {renderChip("Leak Repair", order.Leak_repair)}
//             {renderChip("Faucet Repair", order.Faucet_repair)}
//             {renderChip("Toilet Repair", order.Toilet_repair)}
//             {renderChip("Shower Repair", order.Shower_repair)}
//             {renderChip("Drain Clean", order.Drain_cleaning)}
//           </div>
//         </div>
//       );
//     } else if (service_name === "Electrician") {
//       return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <div>
//             {renderChip("Fan Install", order.Fan_in_un)}
//             {renderChip("Light Install", order.Light_in_un)}
//             {renderChip("Fan Repair", order.Fan_repair)}
//             {renderChip("Light Repair", order.Light_repair)}
//           </div>
//           <div>
//             {renderChip("Switch Repair", order.Switch_repair)}
//             {renderChip("MCB Service", order.MCB_service)}
//             {renderChip("MDB Service", order.MDB_service)}
//           </div>
//         </div>
//       );
//     } else {
//       return <div>Unknown service details</div>;
//     }
//   };
  

//   // ---------- Inline Styles for the Layout ----------
//   const containerStyle = {
//     maxWidth: '1200px',
//     margin: '30px auto',
//     padding: '0 15px',
//   };
//   const dashboardHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '30px',
//   };
//   const dashboardTitleStyle = {
//     fontSize: '28px',
//     fontWeight: '700',
//     color: '#212529',
//     margin: 0,
//   };
//   const dashboardActionsStyle = {
//     display: 'flex',
//     gap: '10px',
//   };
//   const cardStyle = {
//     backgroundColor: '#fff',
//     borderRadius: '8px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//     overflow: 'hidden',
//     padding: '0',
//   };
//   const tableResponsiveStyle = {
//     overflowX: 'auto',
//   };
//   const tableStyle = {
//     marginBottom: 0,
//     width: '100%',
//     borderCollapse: 'collapse',
//   };
//   const tableHeadStyle = {
//     backgroundColor: '#f8f9fa',
//   };
//   const thStyle = {
//     textAlign: 'left',
//     padding: '16px 20px',
//     fontWeight: '600',
//     color: '#495057',
//     fontSize: '14px',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     whiteSpace: 'nowrap',
//     border: '1px solid #dee2e6',
//   };
//   const tdStyle = {
//     padding: '16px 20px',
//     verticalAlign: 'middle',
//     border: '1px solid #dee2e6',
//     fontSize: '14px',
//   };
//   const orderIdStyle = {
//     fontWeight: '600',
//     color: '#4361ee',
//   };
//   const dateStyle = {
//     color: '#6c757d',
//   };
//   const priceStyle = {
//     fontWeight: '600',
//   };
//   const manageBtnStyle = {
//     backgroundColor: '#2ecc71',
//     color: '#fff',
//     padding: '8px 16px',
//     borderRadius: '8px',
//     fontSize: '13px',
//     fontWeight: '500',
//     border: 'none',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//   };
//   const paginationContainerStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     marginTop: '30px',
//   };

//   return (
//     <Container style={containerStyle} fluid>
//       {/* Dashboard Header */}
//       <div style={dashboardHeaderStyle}>
//         <h1 style={dashboardTitleStyle}>Order History</h1>
//         <div style={dashboardActionsStyle}>
//           <Button color="light" style={{ border: '1px solid #dee2e6' }}>
//             <FaFilter style={{ marginRight: '8px' }} />
//             Filter
//           </Button>
//           <Button color="light" style={{ border: '1px solid #dee2e6' }}>
//             <FaDownload style={{ marginRight: '8px' }} />
//             Export
//           </Button>
//           <Button color="primary">
//             <FaPlus style={{ marginRight: '8px' }} />
//             New Order
//           </Button>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <p style={{ color: 'red', marginBottom: '1rem', textAlign: 'center' }}>
//           {error}
//         </p>
//       )}

//       {/* Card with Table */}
//       <Card style={cardStyle}>
//         <div style={tableResponsiveStyle}>
//           <Table hover style={tableStyle}>
//             <thead style={tableHeadStyle}>
//               <tr>
//                 <th style={thStyle}>Order#</th>
//                 <th style={thStyle}>Placed on</th>
//                 <th style={thStyle}>Service</th>
//                 <th style={thStyle}>Order details</th>
//                 <th style={thStyle}>Status</th>
//                 <th style={thStyle}>Countdown</th>
//                 <th style={thStyle}>Total</th>
//                 <th style={thStyle}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.length > 0 ? (
//                 currentOrders.map((order) => {
//                   const placedDate = new Date(order.created_at).toLocaleDateString();
//                   // If your API doesn't return 'due_date', adapt or remove the countdown
//                   // const dueDate = order.date || null;
//                   const dueDate = order.deadline || order.date || null;

//                   return (
//                     <tr key={order.order_number}>
//                       <td style={tdStyle}>
//                         <span style={orderIdStyle}>{order.order_number}</span>
//                       </td>
//                       <td style={tdStyle}>
//                         <span style={dateStyle}>{placedDate}</span>
//                       </td>
//                       <td style={tdStyle}>
//                         <ServiceBadge
//                           service={order.Service?.services_name || 'Unknown'}
//                         />
//                       </td>
//                       <td style={tdStyle}>
//                         <OrderDetails order={order} />
//                       </td>
//                       <td style={tdStyle}>
//                         <StatusBadge status={order.status} />
//                       </td>
//                       <td style={tdStyle}>
//                         <CountdownTimer dueDate={dueDate} status={order.status} />
//                       </td>
//                       <td style={tdStyle}>
//                         <span style={priceStyle}>{order.price} tk</span>
//                       </td>
//                       <td style={tdStyle}>
//                         <button
//                           style={manageBtnStyle}
//                           onClick={() => onManageClick(order)}
//                         >
//                           Manage
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
//                     No orders yet!
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </div>
//       </Card>

//       {/* Pagination */}
//       {currentOrders.length > 0 && (
//         <div style={paginationContainerStyle}>
//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </div>
//       )}
//     </Container>
//   );
// };

// export default OrderHistory;



//************** OrderHistor after update url path ************//


// import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from 'jwt-decode';
// import { FaFilter, FaDownload, FaPlus } from 'react-icons/fa';
// import { Container, Button, Card, Table } from 'reactstrap';
// import { Pagination } from 'react-bootstrap';
// import { URL } from '../../../config';

// const OrderHistory = () => {
//   const [orders, setOrders] = useState([]);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 5;
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith('user-')
//             ? userId.split('user-')[1]
//             : userId;

//           const response = await fetch(`${URL}/user/${extractedUserId}/orders`);
//           if (response.ok) {
//             const orderData = await response.json();
//             // Filter out any orders that have been cancelled by user
//             const filteredOrders = orderData.filter(
//               (order) => order.status !== 'Cancelled'
//             );
//             setOrders(filteredOrders);
//             // setOrders(orderData);
//           } else {
//             setError('Failed to fetch orders');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching order history:', error);
//         setError('An error occurred while fetching order history');
//       }
//     };

//     fetchOrders();
//   }, []);

//   // Pagination logic
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
//   const totalPages = Math.ceil(orders.length / ordersPerPage);

//   const handleManageOrder = (order) => {
//     navigate(`/profile/orderhistory/${order.order_number}`);
//   };

//   // ---------- Countdown Timer ----------
//   const CountdownTimer = ({ dueDate, status }) => {
//     const [timeLeft, setTimeLeft] = useState({});
//     const [isExpired, setIsExpired] = useState(false);

//     useEffect(() => {
//       if (!dueDate || status === 'Completed') return;

//       const targetDate = new Date(dueDate).getTime();

//       const calculateTimeLeft = () => {
//         const now = new Date().getTime();
//         const difference = targetDate - now;

//         if (difference <= 0) {
//           setIsExpired(true);
//           return {
//             days: 0,
//             hours: 0,
//             minutes: 0,
//             seconds: 0,
//           };
//         }

//         return {
//           days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//           hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
//           minutes: Math.floor((difference / 1000 / 60) % 60),
//           seconds: Math.floor((difference / 1000) % 60),
//         };
//       };

//       // Initialize
//       setTimeLeft(calculateTimeLeft());

//       // Update every second
//       const timer = setInterval(() => {
//         setTimeLeft(calculateTimeLeft());
//       }, 1000);

//       // Cleanup
//       return () => clearInterval(timer);
//     }, [dueDate, status]);

//     if (status?.toLowerCase() === 'in-progress') {
//       return (
//         <div style={{ color: '#28a745', fontWeight: '600', fontSize: '12px' }}>
//           Work Started
//         </div>
//       );
//     }

//     if (status === 'Completed') {
//       return (
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//           <span style={{ fontSize: '12px', color: '#6c757d' }}>
//             Order completed
//           </span>
//         </div>
//       );
//     }

//     if (!dueDate) {
//       // If no dueDate is provided
//       return (
//         <div style={{ fontSize: '13px', fontWeight: '500', color: '#6c757d' }}>
//           N/A
//         </div>
//       );
//     }

//     if (isExpired) {
//       return (
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//           <span style={{ fontSize: '12px', color: '#6c757d' }}>Due date</span>
//           <span style={{ color: '#e74c3c', fontWeight: '600' }}>Expired</span>
//         </div>
//       );
//     }

//     // Determine urgency color
//     let difference = new Date(dueDate).getTime() - new Date().getTime();
//     let hoursLeft = difference / (1000 * 60 * 60);

//     // let countdownColor = '#4361ee'; // normal (primary)
//     // if (hoursLeft < 6) countdownColor = '#e74c3c'; // urgent
//     // else if (hoursLeft < 24) countdownColor = '#f39c12'; // warning

//     // Example color changes based on urgency
//    // (You can also remove these if you prefer a single design)
//     let boxBackground = '#ebf2ff'; // default
//     let textColor = '#4361ee'; // default

//     if (hoursLeft < 6) {
//       boxBackground = '#fdecea'; // urgent: light red
//       textColor = '#e74c3c';
//     } else if (hoursLeft < 24) {
//       boxBackground = '#fff5e6'; // warning: light orange
//       textColor = '#f39c12';
//     }

//     // Styles for the timer boxes
//     const boxStyle = {
//       minWidth: '35px',
//       minHeight: '35px',
//       backgroundColor: boxBackground,
//       borderRadius: '5px',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '2px', // Optional small padding
//     };

//     const numberStyle = {
//       fontSize: '14px',    // Smaller font for the number
//       fontWeight: '600',
//       color: textColor,
//       margin: 0,
//     };

//     const labelStyle = {
//       fontSize: '9px',     // Slightly smaller label
//       color: '#6c757d',
//       margin: 0,
//     };

//     const colonStyle = {
//       fontSize: '16px',    // Smaller colon
//       fontWeight: '600',
//       color: textColor,
//       margin: '0 4px',
//     };



//   //   return (
//   //     <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//   //       <span style={{ fontSize: '12px', color: '#6c757d' }}>
//   //         Time remaining
//   //       </span>
//   //       <div
//   //         style={{
//   //           display: 'flex',
//   //           flexWrap: 'wrap',
//   //           gap: '6px',
//   //           fontSize: '13px',
//   //           fontWeight: '500',
//   //         }}
//   //       >
//   //         {timeLeft.days > 0 && (
//   //           <div style={{ display: 'flex', alignItems: 'center' }}>
//   //             <span style={{ fontWeight: '600', color: countdownColor }}>
//   //               {timeLeft.days}
//   //             </span>
//   //             <span style={{ fontSize: '12px', color: '#6c757d' }}>
//   //               &nbsp;day{timeLeft.days !== 1 ? 's' : ''}&nbsp;
//   //             </span>
//   //           </div>
//   //         )}
//   //         <div style={{ display: 'flex', alignItems: 'center' }}>
//   //           <span style={{ fontWeight: '600', color: countdownColor }}>
//   //             {timeLeft.hours}
//   //           </span>
//   //           <span style={{ fontSize: '12px', color: '#6c757d' }}>
//   //             &nbsp;hr&nbsp;
//   //           </span>
//   //         </div>
//   //         <div style={{ display: 'flex', alignItems: 'center' }}>
//   //           <span style={{ fontWeight: '600', color: countdownColor }}>
//   //             {timeLeft.minutes}
//   //           </span>
//   //           <span style={{ fontSize: '12px', color: '#6c757d' }}>
//   //             &nbsp;min&nbsp;
//   //           </span>
//   //         </div>
//   //         <div style={{ display: 'flex', alignItems: 'center' }}>
//   //           <span style={{ fontWeight: '600', color: countdownColor }}>
//   //             {timeLeft.seconds}
//   //           </span>
//   //           <span style={{ fontSize: '12px', color: '#6c757d' }}>
//   //             &nbsp;sec
//   //           </span>
//   //         </div>
//   //       </div>
//   //     </div>
//   //   );
//   // };


//   // Helper to format numbers with a leading zero
//   const formatNumber = (num) => (num < 10 ? `0${num}` : num);
  
//   return (
//     <div style={{ display: 'flex', alignItems: 'center' }}>
//       {/* Days */}
//       <div style={boxStyle}>
//         <p style={numberStyle}>{formatNumber(timeLeft.days)}</p>
//         <p style={labelStyle}>Days</p>
//       </div>
//       <span style={colonStyle}>:</span>

//       {/* Hours */}
//       <div style={boxStyle}>
//         <p style={numberStyle}>{formatNumber(timeLeft.hours)}</p>
//         <p style={labelStyle}>Hours</p>
//       </div>
//       <span style={colonStyle}>:</span>

//       {/* Minutes */}
//       <div style={boxStyle}>
//         <p style={numberStyle}>{formatNumber(timeLeft.minutes)}</p>
//         <p style={labelStyle}>Minutes</p>
//       </div>
//       <span style={colonStyle}>:</span>

//       {/* Seconds */}
//       <div style={boxStyle}>
//         <p style={numberStyle}>{formatNumber(timeLeft.seconds)}</p>
//         <p style={labelStyle}>Seconds</p>
//       </div>
//     </div>
//   );
// };

//   // ---------- Service Badge ----------
//   const ServiceBadge = ({ service }) => {
//     let badgeStyle = {
//       display: 'inline-block',
//       padding: '5px 10px',
//       borderRadius: '20px',
//       fontSize: '12px',
//       fontWeight: '500',
//       textAlign: 'center',
//     };
//     if (service === 'Home Cleaning') {
//       badgeStyle.backgroundColor = '#ebf5ff';
//       badgeStyle.color = '#2b6cb0';
//     } else if (service === 'Plumber') {
//       badgeStyle.backgroundColor = '#e6fffa';
//       badgeStyle.color = '#2c7a7b';
//     } else if (service === 'Electrician') {
//       badgeStyle.backgroundColor = '#fef3c7';
//       badgeStyle.color = '#92400e';
//     } else {
//       badgeStyle.backgroundColor = '#ebf5ff';
//       badgeStyle.color = '#2b6cb0';
//     }
//     return <span style={badgeStyle}>{service}</span>;
//   };

//   // ---------- Status Badge ----------
//   const StatusBadge = ({ status }) => {
//     const baseStyle = {
//       padding: '6px 12px',
//       borderRadius: '20px',
//       fontSize: '13px',
//       fontWeight: '500',
//       textAlign: 'center',
//     };

//     let backgroundColor = '#e6f7ff';
//     let color = '#0958d9';

//     if (status.toLowerCase() === 'completed') {
//       backgroundColor = '#d9f7be';
//       color = '#389e0d';
//     } else if (status.toLowerCase() === 'accepted') {
//       backgroundColor = '#e6f7ff';
//       color = '#0958d9';
//     } else if (status.toLowerCase() === 'pending') {
//       backgroundColor = '#fff3cd';
//       color = '#856404';
//     } else if (status.toLowerCase() === 'rejected') {
//       backgroundColor = '#f8d7da';
//       color = '#721c24';
//     }

//     return (
//       <span style={{ ...baseStyle, backgroundColor, color }}>{status}</span>
//     );
//   };

//   // ---------- Render Order Details ----------
//   const OrderDetails = ({ order }) => {
//     const { service_name } = order;
//     const textStyle = {
//       backgroundColor: "#f8f9fa",
//       padding: "4px 8px",
//       borderRadius: "4px",
//       fontSize: "12px",
//       color: "#495057",
//       marginRight: "8px",
//       marginBottom: "8px",
//       display: "inline-block",
//     };

//     // Helper to show a field only if it's non-zero
//     const renderChip = (label, value) => {
//       if (!value || Number(value) === 0) {
//         return null; // skip if 0 or falsy
//       }
//       return (
//         <span style={textStyle}>
//           {label}: {value}
//         </span>
//       );
//     };

//     if (service_name === "Home Cleaning") {
//       return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <div>
//             {renderChip("Bedroom", order.bed)}
//             {renderChip("Bathroom", order.bath)}
//             {renderChip("Drawing-Dinning", order.dra_din)}
//           </div>
//           <div>
//             {renderChip("Kitchen", order.kitchen)}
//             {renderChip("Cloths", order.cloth)}
//             {renderChip("Dishes", order.dish)}
//           </div>
//         </div>
//       );
//     } else if (service_name === "Plumber") {
//       return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <div>
//             {renderChip("Toilet Install", order.Toilet_in)}
//             {renderChip("Faucet Install", order.Faucet_in)}
//             {renderChip("Sink Install", order.Sink_in)}
//             {renderChip("Dishwasher Install", order.Dishwasher_in)}
//           </div>
//           <div>
//             {renderChip("Leak Repair", order.Leak_repair)}
//             {renderChip("Faucet Repair", order.Faucet_repair)}
//             {renderChip("Toilet Repair", order.Toilet_repair)}
//             {renderChip("Shower Repair", order.Shower_repair)}
//             {renderChip("Drain Clean", order.Drain_cleaning)}
//           </div>
//         </div>
//       );
//     } else if (service_name === "Electrician") {
//       return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <div>
//             {renderChip("Fan Install", order.Fan_in_un)}
//             {renderChip("Light Install", order.Light_in_un)}
//             {renderChip("Fan Repair", order.Fan_repair)}
//             {renderChip("Light Repair", order.Light_repair)}
//           </div>
//           <div>
//             {renderChip("Switch Repair", order.Switch_repair)}
//             {renderChip("MCB Service", order.MCB_service)}
//             {renderChip("MDB Service", order.MDB_service)}
//           </div>
//         </div>
//       );
//     } else {
//       return <div>Unknown service details</div>;
//     }
//   };
  

//   // ---------- Inline Styles for the Layout ----------
//   const containerStyle = {
//     maxWidth: '1200px',
//     margin: '30px auto',
//     padding: '0 15px',
//   };
//   const dashboardHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '30px',
//   };
//   const dashboardTitleStyle = {
//     fontSize: '28px',
//     fontWeight: '700',
//     color: '#212529',
//     margin: 0,
//   };
//   const dashboardActionsStyle = {
//     display: 'flex',
//     gap: '10px',
//   };
//   const cardStyle = {
//     backgroundColor: '#fff',
//     borderRadius: '8px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//     overflow: 'hidden',
//     padding: '0',
//   };
//   const tableResponsiveStyle = {
//     overflowX: 'auto',
//   };
//   const tableStyle = {
//     marginBottom: 0,
//     width: '100%',
//     borderCollapse: 'collapse',
//   };
//   const tableHeadStyle = {
//     backgroundColor: '#f8f9fa',
//   };
//   const thStyle = {
//     textAlign: 'left',
//     padding: '16px 20px',
//     fontWeight: '600',
//     color: '#495057',
//     fontSize: '14px',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     whiteSpace: 'nowrap',
//     border: '1px solid #dee2e6',
//   };
//   const tdStyle = {
//     padding: '16px 20px',
//     verticalAlign: 'middle',
//     border: '1px solid #dee2e6',
//     fontSize: '14px',
//   };
//   const orderIdStyle = {
//     fontWeight: '600',
//     color: '#4361ee',
//   };
//   // const dateStyle = {
//   //   color: '#6c757d',
//   // };
//   const priceStyle = {
//     fontWeight: '600',
//   };
//   const manageBtnStyle = {
//     backgroundColor: '#2ecc71',
//     color: '#fff',
//     padding: '8px 16px',
//     borderRadius: '8px',
//     fontSize: '13px',
//     fontWeight: '500',
//     border: 'none',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//   };
//   const paginationContainerStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     marginTop: '30px',
//   };

//   return (
//     <Container style={containerStyle} fluid>
//       {/* Dashboard Header */}
//       <div style={dashboardHeaderStyle}>
//         <h1 style={dashboardTitleStyle}>Order History</h1>
//         <div style={dashboardActionsStyle}>
//           <Button color="light" style={{ border: '1px solid #dee2e6' }}>
//             <FaFilter style={{ marginRight: '8px' }} />
//             Filter
//           </Button>
//           <Button color="light" style={{ border: '1px solid #dee2e6' }}>
//             <FaDownload style={{ marginRight: '8px' }} />
//             Export
//           </Button>
//           <Button color="primary">
//             <FaPlus style={{ marginRight: '8px' }} />
//             New Order
//           </Button>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <p style={{ color: 'red', marginBottom: '1rem', textAlign: 'center' }}>
//           {error}
//         </p>
//       )}

//       {/* Card with Table */}
//       <Card style={cardStyle}>
//         <div style={tableResponsiveStyle}>
//           <Table hover style={tableStyle}>
//             <thead style={tableHeadStyle}>
//               <tr>
//                 <th style={thStyle}>Order#</th>
//                 {/* <th style={thStyle}>Placed on</th> */}
//                 <th style={thStyle}>Service</th>
//                 <th style={thStyle}>Order details</th>
//                 <th style={thStyle}>Status</th>
//                 <th style={thStyle}>Countdown</th>
//                 <th style={thStyle}>Total</th>
//                 <th style={thStyle}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.length > 0 ? (
//                 currentOrders.map((order) => {
//                   // const placedDate = new Date(order.created_at).toLocaleDateString();

//                   // If your API doesn't return 'due_date', adapt or remove the countdown
//                   // const dueDate = order.date || null;
//                   const dueDate = order.deadline || order.date || null;

//                   return (
//                     <tr key={order.order_number}>
//                       <td style={tdStyle}>
//                         <span style={orderIdStyle}>{order.order_number}</span>
//                       </td>
//                       {/* <td style={tdStyle}>
//                         <span style={dateStyle}>{placedDate}</span>
//                       </td> */}
//                       <td style={tdStyle}>
//                         <ServiceBadge
//                           service={order.Service?.services_name || 'Unknown'}
//                         />
//                       </td>
//                       <td style={tdStyle}>
//                         <OrderDetails order={order} />
//                       </td>
//                       <td style={tdStyle}>
//                         <StatusBadge status={order.status} />
//                       </td>
//                       <td style={tdStyle}>
//                         <CountdownTimer dueDate={dueDate} status={order.status} />
//                       </td>
//                       <td style={tdStyle}>
//                         <span style={priceStyle}>{order.price} tk</span>
//                       </td>
//                       <td style={tdStyle}>
//                         <button
//                           style={manageBtnStyle}
//                           onClick={() => handleManageOrder(order)}
//                         >
//                           Manage
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
//                     No orders yet!
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </div>
//       </Card>

//       {/* Pagination */}
//       {currentOrders.length > 0 && (
//         <div style={paginationContainerStyle}>
//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {[...Array(totalPages)].map((_, index) => (
//               <Pagination.Item
//                 key={index + 1}
//                 active={index + 1 === currentPage}
//                 onClick={() => handlePageChange(index + 1)}
//               >
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </div>
//       )}
//     </Container>
//   );
// };

// export default OrderHistory;











// For making responsive //

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from 'jwt-decode';
// import { FaFilter, FaDownload, FaPlus } from 'react-icons/fa';
// import { Container, Button, Card, Table } from 'reactstrap';
// import { Pagination } from 'react-bootstrap';
// import { URL } from '../../../config';
// import './OrderStyle.css';

// const OrderHistory = () => {
//   const [orders, setOrders] = useState([]);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 5;
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith('user-')
//             ? userId.split('user-')[1]
//             : userId;

//           const response = await fetch(`${URL}/user/${extractedUserId}/orders`);
//           if (response.ok) {
//             const orderData = await response.json();
//             // Filter out any orders that have been cancelled by user
//             const filteredOrders = orderData.filter(
//               (order) => order.status !== 'Cancelled'
//             );
//             setOrders(filteredOrders);
//           } else {
//             setError('Failed to fetch orders');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching order history:', error);
//         setError('An error occurred while fetching order history');
//       }
//     };

//     fetchOrders();
//   }, []);

//   // Pagination logic: Determine which chunk (group of 5 pages) to display.
//   const totalPages = Math.ceil(orders.length / ordersPerPage);
//   const pagesPerChunk = 5;
//   const currentChunk = Math.floor((currentPage - 1) / pagesPerChunk);
//   const startPage = currentChunk * pagesPerChunk + 1;
//   const endPage = Math.min(totalPages, startPage + pagesPerChunk - 1);
//   const nextChunkPage = endPage < totalPages ? endPage + 1 : currentPage;
//   const prevChunkPage = startPage > 1 ? startPage - 1 : currentPage;

//   // Determine orders for the current page.
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handleManageOrder = (order) => {
//     navigate(`/profile/orderhistory/${order.order_number}`);
//   };

//   // ---------- Countdown Timer Component ----------
//   const CountdownTimer = ({ dueDate, status }) => {
//     const [timeLeft, setTimeLeft] = useState({});
//     const [isExpired, setIsExpired] = useState(false);

//     useEffect(() => {
//       if (!dueDate || status === 'Completed') return;

//       const targetDate = new Date(dueDate).getTime();

//       const calculateTimeLeft = () => {
//         const now = new Date().getTime();
//         const difference = targetDate - now;

//         if (difference <= 0) {
//           setIsExpired(true);
//           return { days: 0, hours: 0, minutes: 0, seconds: 0 };
//         }
//         return {
//           days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//           hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
//           minutes: Math.floor((difference / 1000 / 60) % 60),
//           seconds: Math.floor((difference / 1000) % 60),
//         };
//       };

//       setTimeLeft(calculateTimeLeft());

//       const timer = setInterval(() => {
//         setTimeLeft(calculateTimeLeft());
//       }, 1000);

//       return () => clearInterval(timer);
//     }, [dueDate, status]);

//     if (status?.toLowerCase() === 'in-progress') {
//       return (
//         <div className="OrderHistory-countdown-in-progress">
//           Work Started
//         </div>
//       );
//     }

//     if (status === 'Completed') {
//       return (
//         <div className="OrderHistory-countdown-completed">
//           <span>Order completed</span>
//         </div>
//       );
//     }

//     if (!dueDate) {
//       return (
//         <div className="OrderHistory-countdown-na">
//           N/A
//         </div>
//       );
//     }

//     if (isExpired) {
//       return (
//         <div className="OrderHistory-countdown-expired">
//           <span className="OrderHistory-countdown-expired-label">Due date</span>
//           <span className="OrderHistory-countdown-expired-text">Expired</span>
//         </div>
//       );
//     }

//     let difference = new Date(dueDate).getTime() - new Date().getTime();
//     let hoursLeft = difference / (1000 * 60 * 60);
//     let boxBackground = '#ebf2ff';
//     let textColor = '#4361ee';
//     if (hoursLeft < 6) {
//       boxBackground = '#fdecea';
//       textColor = '#e74c3c';
//     } else if (hoursLeft < 24) {
//       boxBackground = '#fff5e6';
//       textColor = '#f39c12';
//     }

//     const boxStyle = {
//       minWidth: '35px',
//       minHeight: '35px',
//       backgroundColor: boxBackground,
//       borderRadius: '5px',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '2px',
//     };

//     const numberStyle = {
//       fontSize: '14px',
//       fontWeight: '600',
//       color: textColor,
//       margin: 0,
//     };

//     const labelStyle = {
//       fontSize: '9px',
//       color: '#6c757d',
//       margin: 0,
//     };

//     const colonStyle = {
//       fontSize: '16px',
//       fontWeight: '600',
//       color: textColor,
//       margin: '0 4px',
//     };

//     const formatNumber = (num) => (num < 10 ? `0${num}` : num);

//     return (
//       <div className="OrderHistory-countdown-timer">
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.days)}</p>
//           <p style={labelStyle}>Days</p>
//         </div>
//         <span style={colonStyle}>:</span>
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.hours)}</p>
//           <p style={labelStyle}>Hours</p>
//         </div>
//         <span style={colonStyle}>:</span>
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.minutes)}</p>
//           <p style={labelStyle}>Minutes</p>
//         </div>
//         <span style={colonStyle}>:</span>
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.seconds)}</p>
//           <p style={labelStyle}>Seconds</p>
//         </div>
//       </div>
//     );
//   };

//   // ---------- Service Badge Component ----------
//   const ServiceBadge = ({ service }) => {
//     let badgeClass = "OrderHistory-service-badge";
//     if (service === 'Home Cleaning') badgeClass += " OrderHistory-cleaning";
//     else if (service === 'Plumber') badgeClass += " OrderHistory-plumber";
//     else if (service === 'Electrician') badgeClass += " OrderHistory-electrician";
//     else badgeClass += " OrderHistory-default";
//     return <span className={badgeClass}>{service}</span>;
//   };

//   // ---------- Status Badge Component ----------
//   const StatusBadge = ({ status }) => {
//     let statusClass = "OrderHistory-status-badge";
//     if (status.toLowerCase() === 'completed') statusClass += " OrderHistory-completed";
//     else if (status.toLowerCase() === 'accepted') statusClass += " OrderHistory-accepted";
//     else if (status.toLowerCase() === 'pending') statusClass += " OrderHistory-pending";
//     else if (status.toLowerCase() === 'rejected') statusClass += " OrderHistory-rejected";
//     return <span className={statusClass}>{status}</span>;
//   };

//   // ---------- Order Details Component ----------
//   const OrderDetails = ({ order }) => {
//     const renderChip = (label, value) => {
//       if (!value || Number(value) === 0) return null;
//       return (
//         <span className="OrderHistory-order-chip">
//           {label}: {value}
//         </span>
//       );
//     };

//     if (order.service_name === "Home Cleaning") {
//       return (
//         <div className="OrderHistory-order-details">
//           <div>
//             {renderChip("Bedroom", order.bed)}
//             {renderChip("Bathroom", order.bath)}
//             {renderChip("Drawing-Dinning", order.dra_din)}
//           </div>
//           <div>
//             {renderChip("Kitchen", order.kitchen)}
//             {renderChip("Cloths", order.cloth)}
//             {renderChip("Dishes", order.dish)}
//           </div>
//         </div>
//       );
//     } else if (order.service_name === "Plumber") {
//       return (
//         <div className="OrderHistory-order-details">
//           <div>
//             {renderChip("Toilet Install", order.Toilet_in)}
//             {renderChip("Faucet Install", order.Faucet_in)}
//             {renderChip("Sink Install", order.Sink_in)}
//             {renderChip("Dishwasher Install", order.Dishwasher_in)}
//           </div>
//           <div>
//             {renderChip("Leak Repair", order.Leak_repair)}
//             {renderChip("Faucet Repair", order.Faucet_repair)}
//             {renderChip("Toilet Repair", order.Toilet_repair)}
//             {renderChip("Shower Repair", order.Shower_repair)}
//             {renderChip("Drain Clean", order.Drain_cleaning)}
//           </div>
//         </div>
//       );
//     } else if (order.service_name === "Electrician") {
//       return (
//         <div className="OrderHistory-order-details">
//           <div>
//             {renderChip("Fan Install", order.Fan_in_un)}
//             {renderChip("Light Install", order.Light_in_un)}
//             {renderChip("Fan Repair", order.Fan_repair)}
//             {renderChip("Light Repair", order.Light_repair)}
//           </div>
//           <div>
//             {renderChip("Switch Repair", order.Switch_repair)}
//             {renderChip("MCB Service", order.MCB_service)}
//             {renderChip("MDB Service", order.MDB_service)}
//           </div>
//         </div>
//       );
//     } else {
//       return <div>Unknown service details</div>;
//     }
//   };

//   return (
//     <Container className="OrderHistory-container" fluid>
//       {/* Dashboard Header */}
//       <div className="OrderHistory-dashboard-header">
//         <h1 className="OrderHistory-dashboard-title">Order History</h1>
//         <div className="OrderHistory-dashboard-actions">
//           <Button color="light" className="OrderHistory-action-btn">
//             <FaFilter className="OrderHistory-icon" /> Filter
//           </Button>
//           <Button color="light" className="OrderHistory-action-btn">
//             <FaDownload className="OrderHistory-icon" /> Export
//           </Button>
//           <Button color="primary" className="OrderHistory-action-btn">
//             <FaPlus className="OrderHistory-icon" /> New Order
//           </Button>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <p className="OrderHistory-error-message">{error}</p>
//       )}

//       {/* Card with Table */}
//       <Card className="OrderHistory-card">
//         <div className="OrderHistory-table-responsive">
//           <Table hover className="OrderHistory-table">
//             <thead className="OrderHistory-table-head">
//               <tr>
//                 <th className="OrderHistory-th">Order#</th>
//                 <th className="OrderHistory-th">Service</th>
//                 <th className="OrderHistory-th">Order details</th>
//                 <th className="OrderHistory-th">Status</th>
//                 <th className="OrderHistory-th">Countdown</th>
//                 <th className="OrderHistory-th">Total</th>
//                 <th className="OrderHistory-th">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.length > 0 ? (
//                 currentOrders.map((order) => {
//                   const dueDate = order.deadline || order.date || null;
//                   return (
//                     <tr key={order.order_number}>
//                       <td className="OrderHistory-td">
//                         <span className="OrderHistory-order-id">{order.order_number}</span>
//                       </td>
//                       <td className="OrderHistory-td">
//                         <ServiceBadge service={order.Service?.services_name || 'Unknown'} />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <OrderDetails order={order} />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <StatusBadge status={order.status} />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <CountdownTimer dueDate={dueDate} status={order.status} />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <span className="OrderHistory-price">{order.price} tk</span>
//                       </td>
//                       <td className="OrderHistory-td">
//                         <button
//                           className="OrderHistory-manage-btn"
//                           onClick={() => handleManageOrder(order)}
//                         >
//                           Manage
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="8" className="OrderHistory-no-orders">
//                     No orders yet!
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </div>
//       </Card>

//       {/* Pagination */}
//       {totalPages > 0 && (
//         <div className="OrderHistory-pagination-container">
//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(prevChunkPage)}
//               disabled={currentPage === 1}
//             />
//             {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
//               <Pagination.Item
//                 key={startPage + i}
//                 active={startPage + i === currentPage}
//                 onClick={() => handlePageChange(startPage + i)}
//               >
//                 {startPage + i}
//               </Pagination.Item>
//             ))}
//             <Pagination.Next
//               onClick={() => handlePageChange(nextChunkPage)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </div>
//       )}
//     </Container>
//   );
// };

// export default OrderHistory;






// Pagination with responsive new updated

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from 'jwt-decode';
// import { FaFilter, FaDownload, FaPlus, FaRedo  } from 'react-icons/fa';
// import { Container, Button, Card, Table } from 'reactstrap';
// import { URL } from '../../../config';
// import './OrderStyle.css';

// const OrderHistory = () => {
//   const [orders, setOrders] = useState([]);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 5;
//   const navigate = useNavigate();

//   // Track if screen is mobile sized (for additional responsive tweaks if needed)
//   // const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   // useEffect(() => {
//   //   const handleResize = () => setIsMobile(window.innerWidth < 768);
//   //   window.addEventListener('resize', handleResize);
//   //   return () => window.removeEventListener('resize', handleResize);
//   // }, []);

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith('user-')
//             ? userId.split('user-')[1]
//             : userId;

//           const response = await fetch(`${URL}/user/${extractedUserId}/orders`);
//           if (response.ok) {
//             const orderData = await response.json();
//             // Filter out any orders that have been cancelled by user
//             const filteredOrders = orderData.filter(
//               (order) => order.status !== 'Cancelled'
//             );
//             setOrders(filteredOrders);
//           } else {
//             setError('Failed to fetch orders');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching order history:', error);
//         setError('An error occurred while fetching order history');
//       }
//     };

//     fetchOrders();
//   }, []);

//   const totalPages = Math.ceil(orders.length / ordersPerPage);
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

//   // Calculate the current result range
//   const rangeStart = orders.length ? indexOfFirstOrder + 1 : 0;
//   const rangeEnd = Math.min(indexOfLastOrder, orders.length);

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//     }
//   };

//   const handleManageOrder = (order) => {
//     navigate(`/profile/orderhistory/${order.order_number}`);
//   };


//   const handleRebook = (order) => {
//     let path = '';
//     switch (order.service_name) {
//       case 'Home Cleaning': path = 'home-cleaning'; break;
//       case 'Plumber':       path = 'plumber';   break;
//       case 'Electrician':   path = 'electrician'; break;
//       default:              path = '';
//     }
//     if (path) {
//       navigate(`/services/${path}`, {
//         state: { fromRebook: true, previousOrder: order }
//       });
//     }
//   };

//   // ---------- Countdown Timer Component ----------
//   const CountdownTimer = ({ dueDate, status }) => {
//     const [timeLeft, setTimeLeft] = useState({});
//     const [isExpired, setIsExpired] = useState(false);

//     useEffect(() => {
//       // if (!dueDate || status === 'Completed') return;
//       if (status === "Cancelled" || status === "Cancelled by Servitor" || !dueDate || status === "Completed") {
//         return;
//       }

//       const targetDate = new Date(dueDate).getTime();

//       const calculateTimeLeft = () => {
//         const now = new Date().getTime();
//         const difference = targetDate - now;

//         if (difference <= 0) {
//           setIsExpired(true);
//           return { days: 0, hours: 0, minutes: 0, seconds: 0 };
//         }
//         return {
//           days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//           hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
//           minutes: Math.floor((difference / 1000 / 60) % 60),
//           seconds: Math.floor((difference / 1000) % 60),
//         };
//       };

//       setTimeLeft(calculateTimeLeft());

//       const timer = setInterval(() => {
//         setTimeLeft(calculateTimeLeft());
//       }, 1000);

//       return () => clearInterval(timer);
//     }, [dueDate, status]);

//     // Conditional rendering based on status
//     if (status === "Cancelled" || status === "Cancelled by Servitor") {
//       return (
//         <div className="OrderHistory-countdown-cancelled">
//           <span>Cancelled order</span>
//         </div>
//       );
//     }

//     if (status?.toLowerCase() === 'in-progress') {
//       return (
//         <div className="OrderHistory-countdown-in-progress">
//           Work Started
//         </div>
//       );
//     }

//     if (status === 'Completed') {
//       return (
//         <div className="OrderHistory-countdown-completed">
//           <span>Order completed</span>
//         </div>
//       );
//     }

//     if (!dueDate) {
//       return (
//         <div className="OrderHistory-countdown-na">
//           N/A
//         </div>
//       );
//     }

//     if (isExpired) {
//       return (
//         <div className="OrderHistory-countdown-expired">
//           <span className="OrderHistory-countdown-expired-label">Due date</span>
//           <span className="OrderHistory-countdown-expired-text">Expired</span>
//         </div>
//       );
//     }

//     let difference = new Date(dueDate).getTime() - new Date().getTime();
//     let hoursLeft = difference / (1000 * 60 * 60);
//     let boxBackground = '#ebf2ff';
//     let textColor = '#4361ee';
//     if (hoursLeft < 6) {
//       boxBackground = '#fdecea';
//       textColor = '#e74c3c';
//     } else if (hoursLeft < 24) {
//       boxBackground = '#fff5e6';
//       textColor = '#f39c12';
//     }

//     const boxStyle = {
//       minWidth: '35px',
//       minHeight: '35px',
//       backgroundColor: boxBackground,
//       borderRadius: '5px',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '2px',
//     };

//     const numberStyle = {
//       fontSize: '14px',
//       fontWeight: '600',
//       color: textColor,
//       margin: 0,
//     };

//     const labelStyle = {
//       fontSize: '9px',
//       color: '#6c757d',
//       margin: 0,
//     };

//     const colonStyle = {
//       fontSize: '16px',
//       fontWeight: '600',
//       color: textColor,
//       margin: '0 4px',
//     };

//     const formatNumber = (num) => (num < 10 ? `0${num}` : num);

//     return (
//       <div className="OrderHistory-countdown-timer">
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.days)}</p>
//           <p style={labelStyle}>Days</p>
//         </div>
//         <span style={colonStyle}>:</span>
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.hours)}</p>
//           <p style={labelStyle}>Hours</p>
//         </div>
//         <span style={colonStyle}>:</span>
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.minutes)}</p>
//           <p style={labelStyle}>Minutes</p>
//         </div>
//         <span style={colonStyle}>:</span>
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.seconds)}</p>
//           <p style={labelStyle}>Seconds</p>
//         </div>
//       </div>
//     );
//   };

//   // ---------- Service Badge Component ----------
//   const ServiceBadge = ({ service }) => {
//     let badgeClass = "OrderHistory-service-badge";
//     if (service === 'Home Cleaning') badgeClass += " OrderHistory-cleaning";
//     else if (service === 'Plumber') badgeClass += " OrderHistory-plumber";
//     else if (service === 'Electrician') badgeClass += " OrderHistory-electrician";
//     else badgeClass += " OrderHistory-default";
//     return <span className={badgeClass}>{service}</span>;
//   };

//   // ---------- Status Badge Component ----------
//   const StatusBadge = ({ status }) => {
//     let statusClass = "OrderHistory-status-badge";
//     if (status.toLowerCase() === 'completed') statusClass += " OrderHistory-completed";
//     else if (status.toLowerCase() === 'accepted') statusClass += " OrderHistory-accepted";
//     else if (status.toLowerCase() === 'pending') statusClass += " OrderHistory-pending";
//     else if (status.toLowerCase() === 'rejected') statusClass += " OrderHistory-rejected";
//     return <span className={statusClass}>{status}</span>;
//   };

//   // ---------- Order Details Component ----------
//   const OrderDetails = ({ order }) => {
//     const renderChip = (label, value) => {
//       if (!value || Number(value) === 0) return null;
//       return (
//         <span className="OrderHistory-order-chip">
//           {label}: {value}
//         </span>
//       );
//     };

//     if (order.service_name === "Home Cleaning") {
//       return (
//         <div className="OrderHistory-order-details">
//           <div>
//             {renderChip("Bedroom", order.bed)}
//             {renderChip("Kitchen", order.kitchen)}
//             {renderChip("Drawing-Dinning", order.dra_din)}
//           </div>
//           <div>
//             {renderChip("Bathroom", order.bath)}
//             {renderChip("Balcony Cleaning", order.balcony)}
//             {renderChip("Window & Grill Cleaning", order.window_grill)}
//           </div>
//           <div>
//             {renderChip("Furniture Cleaning", order.furniture_cleaning)}
//             {renderChip("Cloths", order.cloth)}
//             {renderChip("Dishes", order.dish)}
//           </div>
//         </div>
//       );
//     } else if (order.service_name === "Plumber") {
//       return (
//         <div className="OrderHistory-order-details">
//           <div>
//             {renderChip("Toilet Install", order.Toilet_in)}
//             {renderChip("Faucet Install", order.Faucet_in)}
//             {renderChip("Sink Install", order.Sink_in)}
//             {renderChip("Dishwasher Install", order.Dishwasher_in)}
//           </div>
//           <div>
//             {renderChip("Leak Repair", order.Leak_repair)}
//             {renderChip("Faucet Repair", order.Faucet_repair)}
//             {renderChip("Toilet Repair", order.Toilet_repair)}
//             {renderChip("Shower Repair", order.Shower_repair)}
//             {renderChip("Drain Clean", order.Drain_cleaning)}
//           </div>
//           <div>
//             {renderChip("Pipe Cleaning", order.pipe_cleaning)}
//             {renderChip("Tank Cleaning", order.tank_cleaning)}
//             {renderChip("Issue Checkup", order.issue_checkup ? "Yes" : null)}
//           </div>
//         </div>
//       );
//     } else if (order.service_name === "Electrician") {
//       return (
//         <div className="OrderHistory-order-details">
//           <div>
//             {renderChip("Fan Install", order.Fan_in_un)}
//             {renderChip("Light Install", order.Light_in_un)}
//             {renderChip("Fan Repair", order.Fan_repair)}
//             {renderChip("Light Repair", order.Light_repair)}
//           </div>
//           <div>
//             {renderChip("Switch Repair", order.Switch_repair)}
//             {renderChip("MCB Service", order.MCB_service)}
//             {renderChip("MDB Service", order.MDB_service)}
//           </div>

//           {/* new features */}
//           <div>
//             {renderChip("Regulator Install", order.Fan_regulator_in_un)}
//             {renderChip("Regulator Repair", order.Fan_regulator_repair)}
//             {renderChip("Socket Install", order.Socket_in_un)}
//             {renderChip("Socket Repair", order.Socket_repair)}
//           </div>
//           <div>
//             {renderChip("Breaker Repair", order.Circuit_breaker_repair)}
//             {renderChip("New Wiring Point", order.New_wiring_point)}
//             {renderChip("Full Wiring", order.Full_wiring ? "Yes" : null)}
//             {/* {renderChip("Electrical Checkup", order.Electrical_checkup)} */}
//             {renderChip(
//               "Electrical Checkup",
//               order.Electrical_checkup ? "Yes" : null
//             )}
//           </div>
//         </div>
//       );
//     } else {
//       return <div>Unknown service details</div>;
//     }
//   };

//   return (
//     <Container className="OrderHistory-container" fluid>
//       {/* Dashboard Header */}
//       <div className="OrderHistory-dashboard-header">
//         <h1 className="OrderHistory-dashboard-title">Order History</h1>
//         <div className="OrderHistory-dashboard-actions">
//           <Button color="light" className="OrderHistory-action-btn">
//             <FaFilter className="OrderHistory-icon" /> Filter
//           </Button>
//           <Button color="light" className="OrderHistory-action-btn">
//             <FaDownload className="OrderHistory-icon" /> Export
//           </Button>
//           <Button color="primary" className="OrderHistory-action-btn">
//             <FaPlus className="OrderHistory-icon" /> New Order
//           </Button>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && <p className="OrderHistory-error-message">{error}</p>}

//       {/* Card with Table */}
//       <Card className="OrderHistory-card">
//         <div className="OrderHistory-table-responsive">
//           <Table hover className="OrderHistory-table">
//             <thead className="OrderHistory-table-head">
//               <tr>
//                 <th className="OrderHistory-th">Order#</th>
//                 <th className="OrderHistory-th">Service</th>
//                 <th className="OrderHistory-th">Order details</th>
//                 <th className="OrderHistory-th">Status</th>
//                 <th className="OrderHistory-th">Countdown</th>
//                 <th className="OrderHistory-th">Total</th>
//                 <th className="OrderHistory-th">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.length > 0 ? (
//                 currentOrders.map((order) => {
//                   const dueDate = order.deadline || order.date || null;
//                   return (
//                     <tr key={order.order_number}>
//                       <td className="OrderHistory-td">
//                         <span className="OrderHistory-order-id">
//                           {order.order_number}
//                         </span>
//                       </td>
//                       <td className="OrderHistory-td">
//                         <ServiceBadge
//                           service={order.Service?.services_name || "Unknown"}
//                         />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <OrderDetails order={order} />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <StatusBadge status={order.status} />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <CountdownTimer
//                           dueDate={dueDate}
//                           status={order.status}
//                         />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <span className="OrderHistory-price">
//                           {order.price} tk
//                         </span>
//                       </td>
//                       <td className="OrderHistory-td">
//                         <div className="OrderHistory-action-buttons">
//                           <button
//                             className="OrderHistory-manage-btn"
//                             onClick={() => handleManageOrder(order)}
//                           >
//                             Manage
//                           </button>
//                           {order.status.toLowerCase() === "completed" && (
//                             <button
//                               className="OrderHistory-rebook-btn"
//                               onClick={() => handleRebook(order)}
//                             >
//                               <FaRedo className="OrderHistory-rebook-icon" />
//                               Rebook
//                             </button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="8" className="OrderHistory-no-orders">
//                     No orders yet!
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </div>
//       </Card>

//       {/* Updated Pagination */}
//       <div className="OrderHistory-pagination-container">
//         <span className="OrderHistory-pagination-info">
//           Showing {rangeStart} to {rangeEnd} out of {orders.length}
//         </span>
//         <div className="OrderHistory-pagination-buttons">
//           <Button
//             color="secondary"
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </Button>
//           <Button
//             color="secondary"
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages || orders.length === 0}
//           >
//             Next
//           </Button>
//         </div>
//       </div>
//     </Container>
//   );
// };

// export default OrderHistory;

// ***** Upper code orderhistory All Checked and worked perfectly (23-6-25) ***** //







// ***** Translate Added EN BN and updated (23-6-25) ***** //


// import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from 'jwt-decode';
// import { FaRedo  } from 'react-icons/fa';
// import { Container, Button, Card, Table } from 'reactstrap';
// import { URL } from '../../../config';
// import './OrderStyle.css';
// import { useTranslation } from 'react-i18next';

// const OrderHistory = () => {
//   const { t } = useTranslation();

//   const [orders, setOrders] = useState([]);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const ordersPerPage = 5;
//   const navigate = useNavigate();

//   // Track if screen is mobile sized (for additional responsive tweaks if needed)
//   // const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   // useEffect(() => {
//   //   const handleResize = () => setIsMobile(window.innerWidth < 768);
//   //   window.addEventListener('resize', handleResize);
//   //   return () => window.removeEventListener('resize', handleResize);
//   // }, []);

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith('user-')
//             ? userId.split('user-')[1]
//             : userId;

//           const response = await fetch(`${URL}/user/${extractedUserId}/orders`);
//           if (response.ok) {
//             const orderData = await response.json();
//             // Filter out any orders that have been cancelled by user
//             const filteredOrders = orderData.filter(
//               (order) => order.status !== 'Cancelled'
//             );
//             setOrders(filteredOrders);
//           } else {
//             setError('Failed to fetch orders');
//             // setError(t('orderHistory.messages.fetchError'));
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching order history:', error);
//         setError('An error occurred while fetching order history');
//         // setError(t('orderHistory.messages.generalError'));
//       }
//     };

//     fetchOrders();
//   }, []);

//   const totalPages = Math.ceil(orders.length / ordersPerPage);
//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

//   // Calculate the current result range
//   const rangeStart = orders.length ? indexOfFirstOrder + 1 : 0;
//   const rangeEnd = Math.min(indexOfLastOrder, orders.length);

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//     }
//   };

//   const handleManageOrder = (order) => {
//     navigate(`/profile/orderhistory/${order.order_number}`);
//   };


//   const handleRebook = (order) => {
//     let path = '';
//     switch (order.service_name) {
//       case 'Home Cleaning': path = 'home-cleaning'; break;
//       case 'Plumber':       path = 'plumber';   break;
//       case 'Electrician':   path = 'electrician'; break;
//       default:              path = '';
//     }
//     if (path) {
//       navigate(`/services/${path}`, {
//         state: { fromRebook: true, previousOrder: order }
//       });
//     }
//   };

//   // ---------- Countdown Timer Component ----------
//   const CountdownTimer = ({ dueDate, status }) => {
//     const [timeLeft, setTimeLeft] = useState({});
//     const [isExpired, setIsExpired] = useState(false);

//     useEffect(() => {
//       // if (!dueDate || status === 'Completed') return;
//       if (status === "Cancelled" || status === "Cancelled by Servitor" || !dueDate || status === "Completed") {
//         return;
//       }

//       const targetDate = new Date(dueDate).getTime();

//       const calculateTimeLeft = () => {
//         const now = new Date().getTime();
//         const difference = targetDate - now;

//         if (difference <= 0) {
//           setIsExpired(true);
//           return { days: 0, hours: 0, minutes: 0, seconds: 0 };
//         }
//         return {
//           days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//           hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
//           minutes: Math.floor((difference / 1000 / 60) % 60),
//           seconds: Math.floor((difference / 1000) % 60),
//         };
//       };

//       setTimeLeft(calculateTimeLeft());

//       const timer = setInterval(() => {
//         setTimeLeft(calculateTimeLeft());
//       }, 1000);

//       return () => clearInterval(timer);
//     }, [dueDate, status]);

//     // Conditional rendering based on status
//     if (status === "Cancelled" || status === "Cancelled by Servitor") {
//       return (
//         <div className="OrderHistory-countdown-cancelled">
//           {/* <span>Cancelled order</span> */}
//           <span>{t('orderHistory.countdown.cancelled')}</span>
//         </div>
//       );
//     }

//     if (status?.toLowerCase() === 'in-progress') {
//       return (
//         <div className="OrderHistory-countdown-in-progress">
//           {/* Work Started */}
//           {t('orderHistory.countdown.inProgress')}
//         </div>
//       );
//     }

//     if (status === 'Completed') {
//       return (
//         <div className="OrderHistory-countdown-completed">
//           {/* <span>Order completed</span> */}
//           <span>{t('orderHistory.countdown.completed')}</span>
//         </div>
//       );
//     }

//     if (!dueDate) {
//       return (
//         <div className="OrderHistory-countdown-na">
//           {/* N/A */}
//           {t('orderHistory.countdown.na')}
//         </div>
//       );
//     }

//     if (isExpired) {
//       return (
//         <div className="OrderHistory-countdown-expired">
//           {/* <span className="OrderHistory-countdown-expired-label">Due date</span>
//           <span className="OrderHistory-countdown-expired-text">Expired</span> */}
//           <span className="OrderHistory-countdown-expired-label">{t('orderHistory.countdown.dueDate')}</span>
//           <span className="OrderHistory-countdown-expired-text">{t('orderHistory.countdown.expired')}</span>
//         </div>
//       );
//     }

//     let difference = new Date(dueDate).getTime() - new Date().getTime();
//     let hoursLeft = difference / (1000 * 60 * 60);
//     let boxBackground = '#ebf2ff';
//     let textColor = '#4361ee';
//     if (hoursLeft < 6) {
//       boxBackground = '#fdecea';
//       textColor = '#e74c3c';
//     } else if (hoursLeft < 24) {
//       boxBackground = '#fff5e6';
//       textColor = '#f39c12';
//     }

//     const boxStyle = {
//       minWidth: '35px',
//       minHeight: '35px',
//       backgroundColor: boxBackground,
//       borderRadius: '5px',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '2px',
//     };

//     const numberStyle = {
//       fontSize: '14px',
//       fontWeight: '600',
//       color: textColor,
//       margin: 0,
//     };

//     const labelStyle = {
//       fontSize: '9px',
//       color: '#6c757d',
//       margin: 0,
//     };

//     const colonStyle = {
//       fontSize: '16px',
//       fontWeight: '600',
//       color: textColor,
//       margin: '0 4px',
//     };

//     const formatNumber = (num) => (num < 10 ? `0${num}` : num);

//     return (
//       <div className="OrderHistory-countdown-timer">
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.days)}</p>
//           {/* <p style={labelStyle}>Days</p> */}
//           <p style={labelStyle}>{t('orderHistory.countdown.days')}</p>
//         </div>
//         <span style={colonStyle}>:</span>
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.hours)}</p>
//           {/* <p style={labelStyle}>Hours</p> */}
//           <p style={labelStyle}>{t('orderHistory.countdown.hours')}</p>
//         </div>
//         <span style={colonStyle}>:</span>
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.minutes)}</p>
//           {/* <p style={labelStyle}>Minutes</p> */}
//           <p style={labelStyle}>{t('orderHistory.countdown.minutes')}</p>
//         </div>
//         <span style={colonStyle}>:</span>
//         <div style={boxStyle}>
//           <p style={numberStyle}>{formatNumber(timeLeft.seconds)}</p>
//           {/* <p style={labelStyle}>Seconds</p> */}
//           <p style={labelStyle}>{t('orderHistory.countdown.seconds')}</p>
//         </div>
//       </div>
//     );
//   };

//   // ---------- Service Badge Component ----------
//   const ServiceBadge = ({ service }) => {
//     let badgeClass = "OrderHistory-service-badge";
//     if (service === 'Home Cleaning') badgeClass += " OrderHistory-cleaning";
//     else if (service === 'Plumber') badgeClass += " OrderHistory-plumber";
//     else if (service === 'Electrician') badgeClass += " OrderHistory-electrician";
//     else badgeClass += " OrderHistory-default";
//     return <span className={badgeClass}>{service}</span>;
//   };

//   // ---------- Status Badge Component ----------
//   const StatusBadge = ({ status }) => {
//     let statusClass = "OrderHistory-status-badge";
//     if (status.toLowerCase() === 'completed') statusClass += " OrderHistory-completed";
//     else if (status.toLowerCase() === 'accepted') statusClass += " OrderHistory-accepted";
//     else if (status.toLowerCase() === 'pending') statusClass += " OrderHistory-pending";
//     else if (status.toLowerCase() === 'rejected') statusClass += " OrderHistory-rejected";
//     return <span className={statusClass}>{status}</span>;
//   };

//   // ---------- Order Details Component ----------
//   const OrderDetails = ({ order }) => {
//     const renderChip = (label, value) => {
//       if (!value || Number(value) === 0) return null;
//       return (
//         <span className="OrderHistory-order-chip">
//           {label}: {value}
//         </span>
//       );
//     };

//     if (order.service_name === "Home Cleaning") {
//       return (
//         <div className="OrderHistory-order-details">
//           {/* <div>
//             {renderChip("Bedroom", order.bed)}
//             {renderChip("Kitchen", order.kitchen)}
//             {renderChip("Drawing-Dinning", order.dra_din)}
//           </div>
//           <div>
//             {renderChip("Bathroom", order.bath)}
//             {renderChip("Balcony Cleaning", order.balcony)}
//             {renderChip("Window & Grill Cleaning", order.window_grill)}
//           </div>
//           <div>
//             {renderChip("Furniture Cleaning", order.furniture_cleaning)}
//             {renderChip("Cloths", order.cloth)}
//             {renderChip("Dishes", order.dish)}
//           </div> */}
//           <div>
//             {/* CHANGED: Translated labels */}
//             {renderChip(t('orderHistory.services.homeCleaning.bedroom'), order.bedroom)}
//             {renderChip(t('orderHistory.services.homeCleaning.kitchen'), order.kitchen)}
//             {renderChip(t('orderHistory.services.homeCleaning.drawingDinning'), order.dra_din)}
//           </div>
//           <div>
//             {renderChip(t('orderHistory.services.homeCleaning.bathroom'), order.bath)}
//             {renderChip(t('orderHistory.services.homeCleaning.balconyCleaning'), order.balcony)}
//             {renderChip(t('orderHistory.services.homeCleaning.windowGrillCleaning'), order.window_grill)}
//           </div>
//           <div>
//             {renderChip(t('orderHistory.services.homeCleaning.furnitureCleaning'), order.furniture_cleaning)}
//             {renderChip(t('orderHistory.services.homeCleaning.cloths'), order.cloth)}
//             {renderChip(t('orderHistory.services.homeCleaning.dishes'), order.dish)}
//           </div>
//         </div>
//       );
//     } else if (order.service_name === "Plumber") {
//       return (
//         <div className="OrderHistory-order-details">
//           {/* <div>
//             {renderChip("Toilet Install", order.Toilet_in)}
//             {renderChip("Faucet Install", order.Faucet_in)}
//             {renderChip("Sink Install", order.Sink_in)}
//             {renderChip("Dishwasher Install", order.Dishwasher_in)}
//           </div>
//           <div>
//             {renderChip("Leak Repair", order.Leak_repair)}
//             {renderChip("Faucet Repair", order.Faucet_repair)}
//             {renderChip("Toilet Repair", order.Toilet_repair)}
//             {renderChip("Shower Repair", order.Shower_repair)}
//             {renderChip("Drain Clean", order.Drain_cleaning)}
//           </div>
//           <div>
//             {renderChip("Pipe Cleaning", order.pipe_cleaning)}
//             {renderChip("Tank Cleaning", order.tank_cleaning)}
//             {renderChip("Issue Checkup", order.issue_checkup ? "Yes" : null)}
//           </div> */}

//           <div>
//             {/* CHANGED: Translated labels */}
//             {renderChip(t('orderHistory.services.plumber.toiletInstall'), order.Toilet_in)}
//             {renderChip(t('orderHistory.services.plumber.faucetInstall'), order.Faucet_in)}
//             {renderChip(t('orderHistory.services.plumber.sinkInstall'), order.Sink_in)}
//             {renderChip(t('orderHistory.services.plumber.dishwasherInstall'), order.Dishwasher_in)}
//           </div>
//           <div>
//             {renderChip(t('orderHistory.services.plumber.leakRepair'), order.Leak_repair)}
//             {renderChip(t('orderHistory.services.plumber.faucetRepair'), order.Faucet_repair)}
//             {renderChip(t('orderHistory.services.plumber.toiletRepair'), order.Toilet_repair)}
//             {renderChip(t('orderHistory.services.plumber.showerRepair'), order.Shower_repair)}
//             {renderChip(t('orderHistory.services.plumber.drainClean'), order.Drain_cleaning)}
//           </div>
//           <div>
//             {renderChip(t('orderHistory.services.plumber.pipeCleaning'), order.pipe_cleaning)}
//             {renderChip(t('orderHistory.services.plumber.tankCleaning'), order.tank_cleaning)}
//             {renderChip(t('orderHistory.services.plumber.issueCheckup'), order.issue_checkup ? t('Yes') : null)}
//           </div>
//         </div>
//       );
//     } else if (order.service_name === "Electrician") {
//       return (
//         <div className="OrderHistory-order-details">
//           {/* <div>
//             {renderChip("Fan Install", order.Fan_in_un)}
//             {renderChip("Light Install", order.Light_in_un)}
//             {renderChip("Fan Repair", order.Fan_repair)}
//             {renderChip("Light Repair", order.Light_repair)}
//           </div>
//           <div>
//             {renderChip("Switch Repair", order.Switch_repair)}
//             {renderChip("MCB Service", order.MCB_service)}
//             {renderChip("MDB Service", order.MDB_service)}
//           </div>
//           <div>
//             {renderChip("Regulator Install", order.Fan_regulator_in_un)}
//             {renderChip("Regulator Repair", order.Fan_regulator_repair)}
//             {renderChip("Socket Install", order.Socket_in_un)}
//             {renderChip("Socket Repair", order.Socket_repair)}
//           </div>
//           <div>
//             {renderChip("Breaker Repair", order.Circuit_breaker_repair)}
//             {renderChip("New Wiring Point", order.New_wiring_point)}
//             {renderChip("Full Wiring", order.Full_wiring ? "Yes" : null)}
//             {renderChip(
//               "Electrical Checkup",
//               order.Electrical_checkup ? "Yes" : null
//             )}
//           </div> */}

//           <div>
//             {/* CHANGED: Translated labels */}
//             {renderChip(t('orderHistory.services.electrician.fanInstall'), order.Fan_in_un)}
//             {renderChip(t('orderHistory.services.electrician.lightInstall'), order.Light_in_un)}
//             {renderChip(t('orderHistory.services.electrician.fanRepair'), order.Fan_repair)}
//             {renderChip(t('orderHistory.services.electrician.lightRepair'), order.Light_repair)}
//           </div>
//           <div>
//             {renderChip(t('orderHistory.services.electrician.switchRepair'), order.Switch_repair)}
//             {renderChip(t('orderHistory.services.electrician.mcbService'), order.MCB_service)}
//             {renderChip(t('orderHistory.services.electrician.mdbService'), order.MDB_service)}
//           </div>
//           <div>
//             {renderChip(t('orderHistory.services.electrician.regulatorInstall'), order.Fan_regulator_in_un)}
//             {renderChip(t('orderHistory.services.electrician.regulatorRepair'), order.Fan_regulator_repair)}
//             {renderChip(t('orderHistory.services.electrician.socketInstall'), order.Socket_in_un)}
//             {renderChip(t('orderHistory.services.electrician.socketRepair'), order.Socket_repair)}
//           </div>
//           <div>
//             {renderChip(t('orderHistory.services.electrician.breakerRepair'), order.Circuit_breaker_repair)}
//             {renderChip(t('orderHistory.services.electrician.newWiringPoint'), order.New_wiring_point)}
//             {renderChip(t('orderHistory.services.electrician.fullWiring'), order.Full_wiring ? t('Yes') : null)}
//             {renderChip(t('orderHistory.services.electrician.electricalCheckup'), order.Electrical_checkup ? t('Yes') : null)}
//           </div>
//         </div>
//       );
//     } else {
//       return <div>Unknown service details</div>;
//     }
//   };

//   return (
//     <Container className="OrderHistory-container" fluid>
//       {/* Dashboard Header */}
//       <div className="OrderHistory-dashboard-header">
//         {/* <h1 className="OrderHistory-dashboard-title">Order History</h1> */}
//         <h1 className="OrderHistory-dashboard-title">{t('orderHistory.title')}</h1>

//         {/* <div className="OrderHistory-dashboard-actions">
//           <Button color="light" className="OrderHistory-action-btn">
//             <FaFilter className="OrderHistory-icon" /> Filter
//           </Button>
//           <Button color="light" className="OrderHistory-action-btn">
//             <FaDownload className="OrderHistory-icon" /> Export
//           </Button>
//           <Button color="primary" className="OrderHistory-action-btn">
//             <FaPlus className="OrderHistory-icon" /> New Order
//           </Button>
//         </div> */}
//       </div>

//       {/* Error Message */}
//       {error && <p className="OrderHistory-error-message">{error}</p>}

//       {/* Card with Table */}
//       <Card className="OrderHistory-card">
//         <div className="OrderHistory-table-responsive">
//           <Table hover className="OrderHistory-table">
//             <thead className="OrderHistory-table-head">
//               <tr>
//                 {/* <th className="OrderHistory-th">Order#</th>
//                 <th className="OrderHistory-th">Service</th>
//                 <th className="OrderHistory-th">Order details</th>
//                 <th className="OrderHistory-th">Status</th>
//                 <th className="OrderHistory-th">Countdown</th>
//                 <th className="OrderHistory-th">Total</th>
//                 <th className="OrderHistory-th">Action</th> */}

//                 <th className="OrderHistory-th">{t('orderHistory.tableHeaders.orderNumber')}</th>
//                 <th className="OrderHistory-th">{t('orderHistory.tableHeaders.service')}</th>
//                 <th className="OrderHistory-th">{t('orderHistory.tableHeaders.orderDetails')}</th>
//                 <th className="OrderHistory-th">{t('orderHistory.tableHeaders.status')}</th>
//                 <th className="OrderHistory-th">{t('orderHistory.tableHeaders.countdown')}</th>
//                 <th className="OrderHistory-th">{t('orderHistory.tableHeaders.total')}</th>
//                 <th className="OrderHistory-th">{t('orderHistory.tableHeaders.action')}</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentOrders.length > 0 ? (
//                 currentOrders.map((order) => {
//                   const dueDate = order.deadline || order.date || null;
//                   return (
//                     <tr key={order.order_number}>
//                       <td className="OrderHistory-td">
//                         <span className="OrderHistory-order-id">
//                           {order.order_number}
//                         </span>
//                       </td>
//                       <td className="OrderHistory-td">
//                         <ServiceBadge
//                           service={order.Service?.services_name || "Unknown"}
//                         />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <OrderDetails order={order} />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <StatusBadge status={order.status} />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <CountdownTimer
//                           dueDate={dueDate}
//                           status={order.status}
//                         />
//                       </td>
//                       <td className="OrderHistory-td">
//                         <span className="OrderHistory-price">
//                           {order.price} tk
//                         </span>
//                       </td>
//                       <td className="OrderHistory-td">
//                         <div className="OrderHistory-action-buttons">
//                           <button
//                             className="OrderHistory-manage-btn"
//                             onClick={() => handleManageOrder(order)}
//                           >
//                             {/* Manage */}
//                             {t('orderHistory.buttons.manage')}
//                           </button>
//                           {order.status.toLowerCase() === "completed" && (
//                             <button
//                               className="OrderHistory-rebook-btn"
//                               onClick={() => handleRebook(order)}
//                             >
//                               <FaRedo className="OrderHistory-rebook-icon" />
//                               {/* Rebook */}
//                               {t('orderHistory.buttons.rebook')}
//                             </button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="8" className="OrderHistory-no-orders">
//                     {/* No orders yet! */}
//                     {t('orderHistory.messages.noOrders')}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </div>
//       </Card>

//       {/* Updated Pagination */}
//       <div className="OrderHistory-pagination-container">
//         <span className="OrderHistory-pagination-info">
//           {/* Showing {rangeStart} to {rangeEnd} out of {orders.length} */}

//           {t('orderHistory.pagination.showing', { start: rangeStart, end: rangeEnd, total: orders.length })}
//         </span>
//         <div className="OrderHistory-pagination-buttons">
//           <Button
//             color="secondary"
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//           >
//             {/* Previous */}
//             {t('orderHistory.buttons.previous')}
//           </Button>
//           <Button
//             color="secondary"
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages || orders.length === 0}
//           >
//             {/* Next */}
//             {t('orderHistory.buttons.next')}
//           </Button>
//         </div>
//       </div>
//     </Container>
//   );
// };

// export default OrderHistory;


// ***** Check uppper codes is all okay (8-7-25) ***** //





// ***** New Design Update for Mobile View Table Design (8-7-25) ***** //


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { FaRedo, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Container, Button, Card, Table } from "reactstrap";
import { URL } from "../../../config";
import "./OrderStyle.css";
import { useTranslation } from "react-i18next";
import { serviceFields } from "../../Services/serviceFields";
import Loader from "../../../Components/LoaderSpin/Loader";

const OrderHistory = () => {
  const { t } = useTranslation();

  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 5;
  const navigate = useNavigate();

  // Track if screen is mobile sized (for additional responsive tweaks if needed)
  // const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // useEffect(() => {
  //   const handleResize = () => setIsMobile(window.innerWidth < 768);
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  const [expandedOrder, setExpandedOrder] = useState(null);
    const toggleDetails = (orderId) => {
    setExpandedOrder((prev) => (prev === orderId ? null : orderId));
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken = jwtDecode(token);
          const userId = decodedToken.Id;
          const extractedUserId = userId.startsWith("user-")
            ? userId.split("user-")[1]
            : userId;

          const response = await fetch(`${URL}/user/${extractedUserId}/orders`);
          if (response.ok) {
            const orderData = await response.json();
            // Filter out any orders that have been cancelled by user

            // const filteredOrders = orderData.filter(
            //   (order) => order.status !== "Cancelled"
            // );
            setOrders(orderData);
          } else {
            setError("Failed to fetch orders");
            // setError(t('orderHistory.messages.fetchError'));
          }
        }
      } catch (error) {
        console.error("Error fetching order history:", error);
        setError("An error occurred while fetching order history");
        // setError(t('orderHistory.messages.generalError'));
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const totalPages = Math.ceil(orders.length / ordersPerPage);
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

  // Calculate the current result range
  const rangeStart = orders.length ? indexOfFirstOrder + 1 : 0;
  const rangeEnd = Math.min(indexOfLastOrder, orders.length);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleManageOrder = (order) => {
    navigate(`/profile/orderhistory/${order.order_number}`);
  };

  const handleRebook = (order) => {
    let path = "";
    switch (order.service_name) {
      case "Home Cleaning":
        path = "home-cleaning";
        break;
      case "Plumber":
        path = "plumber";
        break;
      case "Electrician":
        path = "electrician";
        break;
      case "Gas Chula":
        path = "gas-chula";
        break;
      case "AC Service":
        path = "ac-service";
        break;
      case "Filter":
        path = "filter";
        break;
      case "Tutor Service": 
        path = "tutor-service";
        break;
      default:
        path = "";
    }
    if (path) {
      navigate(`/services/${path}`, {
        state: { fromRebook: true, previousOrder: order },
      });
    }
  };

  // ---------- Countdown Timer Component ----------
  const CountdownTimer = ({ dueDate, status }) => {
    const [timeLeft, setTimeLeft] = useState({});
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
      // if (!dueDate || status === 'Completed') return;
      if (
        status === "Cancelled" ||
        status === "Cancelled by Servitor" ||
        !dueDate ||
        status === "Completed"
      ) {
        return;
      }

      const targetDate = new Date(dueDate).getTime();

      const calculateTimeLeft = () => {
        const now = new Date().getTime();
        const difference = targetDate - now;

        if (difference <= 0) {
          setIsExpired(true);
          return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }
        return {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        };
      };

      setTimeLeft(calculateTimeLeft());

      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearInterval(timer);
    }, [dueDate, status]);

    // Conditional rendering based on status
    if (status === "Cancelled" || status === "Cancelled by Servitor") {
      return (
        <div className="OrderHistory-countdown-cancelled">
          {/* <span>Cancelled order</span> */}
          <span>{t("orderHistory.countdown.cancelled")}</span>
        </div>
      );
    }

    if (status?.toLowerCase() === "in-progress") {
      return (
        <div className="OrderHistory-countdown-in-progress">
          {/* Work Started */}
          {t("orderHistory.countdown.inProgress")}
        </div>
      );
    }

    if (status === "Completed") {
      return (
        <div className="OrderHistory-countdown-completed">
          {/* <span>Order completed</span> */}
          <span>{t("orderHistory.countdown.completed")}</span>
        </div>
      );
    }

    if (!dueDate) {
      return (
        <div className="OrderHistory-countdown-na">
          {/* N/A */}
          {t("orderHistory.countdown.na")}
        </div>
      );
    }

    if (isExpired) {
      return (
        <div className="OrderHistory-countdown-expired">
          {/* <span className="OrderHistory-countdown-expired-label">Due date</span>
          <span className="OrderHistory-countdown-expired-text">Expired</span> */}
          <span className="OrderHistory-countdown-expired-label">
            {t("orderHistory.countdown.dueDate")}
          </span>
          <span className="OrderHistory-countdown-expired-text">
            {t("orderHistory.countdown.expired")}
          </span>
        </div>
      );
    }

    let difference = new Date(dueDate).getTime() - new Date().getTime();
    let hoursLeft = difference / (1000 * 60 * 60);
    let boxBackground = "#ebf2ff";
    let textColor = "#4361ee";
    if (hoursLeft < 6) {
      boxBackground = "#fdecea";
      textColor = "#e74c3c";
    } else if (hoursLeft < 24) {
      boxBackground = "#fff5e6";
      textColor = "#f39c12";
    }

    const boxStyle = {
      minWidth: "35px",
      minHeight: "35px",
      backgroundColor: boxBackground,
      borderRadius: "5px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2px",
    };

    const numberStyle = {
      fontSize: "14px",
      fontWeight: "600",
      color: textColor,
      margin: 0,
    };

    const labelStyle = {
      fontSize: "9px",
      color: "#6c757d",
      margin: 0,
    };

    const colonStyle = {
      fontSize: "16px",
      fontWeight: "600",
      color: textColor,
      margin: "0 4px",
    };

    const formatNumber = (num) => (num < 10 ? `0${num}` : num);

    return (
      <div className="OrderHistory-countdown-timer">
        <div style={boxStyle}>
          <p style={numberStyle}>{formatNumber(timeLeft.days)}</p>
          {/* <p style={labelStyle}>Days</p> */}
          <p style={labelStyle}>{t("orderHistory.countdown.days")}</p>
        </div>
        <span style={colonStyle}>:</span>
        <div style={boxStyle}>
          <p style={numberStyle}>{formatNumber(timeLeft.hours)}</p>
          {/* <p style={labelStyle}>Hours</p> */}
          <p style={labelStyle}>{t("orderHistory.countdown.hours")}</p>
        </div>
        <span style={colonStyle}>:</span>
        <div style={boxStyle}>
          <p style={numberStyle}>{formatNumber(timeLeft.minutes)}</p>
          {/* <p style={labelStyle}>Minutes</p> */}
          <p style={labelStyle}>{t("orderHistory.countdown.minutes")}</p>
        </div>
        <span style={colonStyle}>:</span>
        <div style={boxStyle}>
          <p style={numberStyle}>{formatNumber(timeLeft.seconds)}</p>
          {/* <p style={labelStyle}>Seconds</p> */}
          <p style={labelStyle}>{t("orderHistory.countdown.seconds")}</p>
        </div>
      </div>
    );
  };

  // ---------- Service Badge Component ----------
  const ServiceBadge = ({ service }) => {
    let badgeClass = "OrderHistory-service-badge";
    if (service === "Home Cleaning") badgeClass += " OrderHistory-cleaning";
    else if (service === "Plumber") badgeClass += " OrderHistory-plumber";
    else if (service === "Electrician")
      badgeClass += " OrderHistory-electrician";
    else if (service === "Gas Chula") badgeClass += " OrderHistory-gaschula";
    else if (service === "AC Service") badgeClass += " OrderHistory-ac";
    else if (service === "Filter") badgeClass += " OrderHistory-filter";
    else if (service === "Tutor Service") badgeClass += " OrderHistory-tutor";
    else badgeClass += " OrderHistory-default";
    return <span className={badgeClass}>{service}</span>;
  };

  // ---------- Status Badge Component ----------
  const StatusBadge = ({ status }) => {
    let statusClass = "OrderHistory-status-badge";
    if (status.toLowerCase() === "completed")
      statusClass += " OrderHistory-completed";
    else if (status.toLowerCase() === "accepted")
      statusClass += " OrderHistory-accepted";
    else if (status.toLowerCase() === "pending")
      statusClass += " OrderHistory-pending";
    else if (status.toLowerCase() === "rejected")
      statusClass += " OrderHistory-rejected";
    else if (status.toLowerCase() === "cancelled")
      statusClass += " OrderHistory-cancelled";

    else if (status.toLowerCase() === "in-progress")
      statusClass += " OrderHistory-in-progress";
    else if (status.toLowerCase() === "deadline-timeout")
      statusClass += " OrderHistory-deadline-timeout";
    return <span className={statusClass}>{status}</span>;
  };

  // ---------- Order Details Component ----------


  const OrderDetails = ({ order }) => {
  const { t } = useTranslation();

  // 1) pick the right field list (or empty)
  const fields = serviceFields[order.service_name] || [];

  // 2) map→filter→format into { label, value } pairs
  const visible = fields
    .map(({ prop, labelKey, type }) => {
      const raw = order[prop];
      // boolean only if true
      if (type === "boolean") return raw ? { label: t(labelKey), value: "Yes" } : null;
      // number skip zero
      if (type === "number" && Number(raw) === 0) return null;
      // text skip empty
      if (type === "text" && !raw) return null;
      return { label: t(labelKey), value: raw };
    })
    .filter(Boolean);


    // *** Add New Custom Service Order (5-january-2026) *** //
    //  Add Custom Services (from backend: order.customServices OR fallback: order.custom_service_json)
    let customItems = [];

    // 1) if backend already sends parsed array
    if (Array.isArray(order?.customServices)) {
      customItems = order.customServices;
    } else if (order?.custom_service_json) {
      // 2) fallback: parse JSON string if needed
      try {
        const parsed = typeof order.custom_service_json === "string"
          ? JSON.parse(order.custom_service_json)
          : order.custom_service_json;

        if (Array.isArray(parsed)) customItems = parsed;
      } catch (e) {
        customItems = [];
      }
    }

    //  push custom items into visible chips
    customItems.forEach((c) => {
      const name = String(c?.name || "").trim();
      const price = Number(c?.price || 0);

      if (!name) return;

      visible.push({
        label: "Custom Service",
        value: `${name} (${price} tk)`,
      });
    });

    // *** End New Custom Service Order (5-january-2026) *** //

  // 3) chunk into rows of 2
  const rows = [];
  for (let i = 0; i < visible.length; i += 2) {
    rows.push(visible.slice(i, i + 2));
  }

  return (

    <div className="OrderHistory-order-details">
      {rows.map((row, idx) => (
        <div key={idx}>
          {row.map((f, i) => (
            <span key={i} className="OrderHistory-order-chip">
              {f.label}: {f.value}
            </span>
          ))}
        </div>
      ))}
    </div>
   );
 };

  // const OrderDetails = ({ order }) => {
  //   const renderChip = (label, value) => {
  //     if (!value || Number(value) === 0) return null;
  //     return (
  //       <span className="OrderHistory-order-chip">
  //         {label}: {value}
  //       </span>
  //     );
  //   };

  //   if (order.service_name === "Home Cleaning") {
  //     return (
  //       <div className="OrderHistory-order-details">
  //         <div>
  //           {/* CHANGED: Translated labels */}
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.bedroom"),
  //             order.bedroom
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.kitchen"),
  //             order.kitchen
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.drawingDinning"),
  //             order.dra_din
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.balconyCleaning"),
  //             order.balcony
  //           )}
  //         </div>
  //         <div>
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.bathroom"),
  //             order.bath
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.windowGrillCleaning"),
  //             order.window_grill
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.stairsfloorCleaning"),
  //             order.stairs_and_railing
  //           )}
  //         </div>
  //         <div>
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.furnitureCleaning"),
  //             order.furniture_cleaning
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.cloths"),
  //             order.cloth
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.dishes"),
  //             order.dish
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.homeCleaning.carpetCleaning"),
  //             order.carpet_cleaning
  //           )}
  //         </div>
  //       </div>
  //     );
  //   } else if (order.service_name === "Plumber") {
  //     return (
  //       <div className="OrderHistory-order-details">
      
  //         <div>
  //           {/* CHANGED: Translated labels */}
  //           {renderChip(
  //             t("orderHistory.services.plumber.toiletInstall"),
  //             order.Toilet_in
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.faucetInstall"),
  //             order.Faucet_in
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.sinkInstall"),
  //             order.Sink_in
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.dishwasherInstall"),
  //             order.Dishwasher_in
  //           )}
  //         </div>
  //         <div>
  //           {renderChip(
  //             t("orderHistory.services.plumber.leakRepair"),
  //             order.Leak_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.faucetRepair"),
  //             order.Faucet_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.toiletRepair"),
  //             order.Toilet_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.showerRepair"),
  //             order.Shower_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.drainClean"),
  //             order.Drain_cleaning
  //           )}
  //         </div>
  //         <div>
  //           {renderChip(
  //             t("orderHistory.services.plumber.pipeCleaning"),
  //             order.pipe_cleaning
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.tankCleaning"),
  //             order.tank_cleaning
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.geyser_install"),
  //             order.geyser_setup
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.geyser_repair"),
  //             order.geyser_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.plumber.issueCheckup"),
  //             order.issue_checkup ? t("Yes") : null
  //           )}
  //         </div>
  //       </div>
  //     );
  //   } else if (order.service_name === "Electrician") {
  //     return (
  //       <div className="OrderHistory-order-details">
  //         <div>
  //           {/* CHANGED: Translated labels */}
  //           {renderChip(
  //             t("orderHistory.services.electrician.fanInstall"),
  //             order.Fan_in_un
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.lightInstall"),
  //             order.Light_in_un
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.fanRepair"),
  //             order.Fan_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.lightRepair"),
  //             order.Light_repair
  //           )}
  //         </div>
  //         <div>
  //           {renderChip(
  //             t("orderHistory.services.electrician.switchRepair"),
  //             order.Switch_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.mcbService"),
  //             order.MCB_service
  //           )}

  //           {renderChip(
  //             t("orderHistory.services.electrician.mdbService"),
  //             order.MDB_service
  //           )}
  //         </div>

  //         <div>

  //         {renderChip(
  //             t("orderHistory.services.electrician.Doorbellsetup"),
  //             order.Doorbell_setup
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.Exhaustfansetup"),
  //             order.Exhaust_fan_setup
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.Exhaustfanrepair"),
  //             order.Exhaust_fan_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.Drillwallholes"),
  //             order.Drill_wall_holes
  //           )}
  //         </div>

  //         <div>
  //           {renderChip(
  //             t("orderHistory.services.electrician.regulatorInstall"),
  //             order.Fan_regulator_in_un
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.regulatorRepair"),
  //             order.Fan_regulator_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.socketInstall"),
  //             order.Socket_in_un
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.socketRepair"),
  //             order.Socket_repair
  //           )}
  //         </div>
  //         <div>
  //           {renderChip(
  //             t("orderHistory.services.electrician.breakerRepair"),
  //             order.Circuit_breaker_repair
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.newWiringPoint"),
  //             order.New_wiring_point
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.fullWiring"),
  //             order.Full_wiring ? t("Yes") : null
  //           )}
  //           {renderChip(
  //             t("orderHistory.services.electrician.electricalCheckup"),
  //             order.Electrical_checkup ? t("Yes") : null
  //           )}
  //         </div>
  //       </div>
  //     );
  //   }
  //   else if (order.service_name === "Gas Chula") {
  //   return (
  //     <div className="OrderHistory-order-details">
  //       <div>
  //         {renderChip(
  //           t("orderHistory.services.gasChula.cylinderType"),
  //           order.chulaCylinderType
  //         )}
  //         {renderChip(
  //           t("orderHistory.services.gasChula.newSetup"),
  //           order.NewchulaSetup
  //         )}
  //         {renderChip(
  //           t("orderHistory.services.gasChula.chulaSetup"),
  //           order.chulaSetup
  //         )}
  //       </div>
  //       <div>
  //         {renderChip(
  //           t("orderHistory.services.gasChula.burnerSetup"),
  //           order.burnerSetup
  //         )}
  //         {renderChip(
  //           t("orderHistory.services.gasChula.burnerCleaning"),
  //           order.burnerCleaning
  //         )}
  //         {renderChip(
  //           t("orderHistory.services.gasChula.nozzleReplacement"),
  //           order.nozzleReplacement
  //         )}
  //       </div>
  //       <div>
  //         {renderChip(
  //           t("orderHistory.services.gasChula.checkIssues"),
  //           order.checkIssues ? t("Yes") : null
  //         )}
  //       </div>
  //     </div>
  //   );
  // } else {
  //     return <div>Unknown service details</div>;
  //   }
  // };

  return (
    <Container className="OrderHistory-container" fluid>

      <Loader show={loading} />
      
      {/* Dashboard Header */}
      <div className="OrderHistory-dashboard-header">
        {/* <h1 className="OrderHistory-dashboard-title">Order History</h1> */}
        <h1 className="OrderHistory-dashboard-title">
          {t("orderHistory.title")}
        </h1>

        {/* <div className="OrderHistory-dashboard-actions">
          <Button color="light" className="OrderHistory-action-btn">
            <FaFilter className="OrderHistory-icon" /> Filter
          </Button>
          <Button color="light" className="OrderHistory-action-btn">
            <FaDownload className="OrderHistory-icon" /> Export
          </Button>
          <Button color="primary" className="OrderHistory-action-btn">
            <FaPlus className="OrderHistory-icon" /> New Order
          </Button>
        </div> */}
      </div>

      {/* Error Message */}
      {error && <p className="OrderHistory-error-message">{error}</p>}

      {/* Card with Table */}
      <Card className="OrderHistory-card OrderHistory-desktop-view">
        <div className="OrderHistory-table-responsive">
          <Table hover className="OrderHistory-table">
            <thead className="OrderHistory-table-head">
              <tr>
                {/* <th className="OrderHistory-th">Order#</th>
                <th className="OrderHistory-th">Service</th>
                <th className="OrderHistory-th">Order details</th>
                <th className="OrderHistory-th">Status</th>
                <th className="OrderHistory-th">Countdown</th>
                <th className="OrderHistory-th">Total</th>
                <th className="OrderHistory-th">Action</th> */}

                <th className="OrderHistory-th">
                  {t("orderHistory.tableHeaders.orderNumber")}
                </th>
                <th className="OrderHistory-th">
                  {t("orderHistory.tableHeaders.service")}
                </th>
                <th className="OrderHistory-th">
                  {t("orderHistory.tableHeaders.orderDetails")}
                </th>
                <th className="OrderHistory-th">
                  {t("orderHistory.tableHeaders.status")}
                </th>
                <th className="OrderHistory-th">
                  {t("orderHistory.tableHeaders.countdown")}
                </th>
                <th className="OrderHistory-th">
                  {t("orderHistory.tableHeaders.total")}
                </th>
                <th className="OrderHistory-th">
                  {t("orderHistory.tableHeaders.action")}
                </th>
              </tr>
            </thead>
            <tbody>
              {currentOrders.length > 0 ? (
                currentOrders.map((order) => {
                  const dueDate = order.deadline || order.date || null;
                  return (
                    <tr key={order.order_number}>
                      <td className="OrderHistory-td">
                        <span className="OrderHistory-order-id">
                          {order.order_number}
                        </span>
                      </td>
                      <td className="OrderHistory-td">
                        <ServiceBadge
                          service={order.Service?.services_name || "Unknown"}
                        />
                      </td>
                      <td className="OrderHistory-td">
                        {/* <OrderDetails order={order} /> */}
                        {/* <ServiceOrderDetailsList order={order} /> */}

                        <button
                          className="OrderHistory-view-btn"
                          onClick={() => toggleDetails(order.order_number)}
                        >
                          {/* {expandedOrder === order.order_number ? "Hide Details" : "View Details"} */}
                          {expandedOrder === order.order_number ? (
                              <>
                                {/* <FaChevronUp /> Hide List */}
                                <FaChevronUp /> {t("orderHistory.hideList")}
                              </>
                            ) : (
                              <>
                                {/* <FaChevronDown /> View List */}
                                <FaChevronDown /> {t("orderHistory.viewList")}
                              </>
                            )}

                        </button>

                        <div
                          className={`OrderHistory-details-collapse ${
                            expandedOrder === order.order_number ? "open" : ""
                          }`}
                        >
                          <OrderDetails order={order} />
                        </div>

                      </td>
                      <td className="OrderHistory-td">
                        <StatusBadge status={order.status} />
                      </td>
                      <td className="OrderHistory-td">
                        <CountdownTimer
                          dueDate={dueDate}
                          status={order.status}
                        />
                      </td>
                      <td className="OrderHistory-td">
                        <span className="OrderHistory-price">
                          {order.price} tk
                        </span>
                      </td>
                      <td className="OrderHistory-td">
                        <div className="OrderHistory-action-buttons">
                          <button
                            className="OrderHistory-manage-btn"
                            onClick={() => handleManageOrder(order)}
                          >
                            {/* Manage */}
                            {t("orderHistory.buttons.manage")}
                          </button>
                          {order.status.toLowerCase() === "completed" && (
                            <button
                              className="OrderHistory-rebook-btn"
                              onClick={() => handleRebook(order)}
                            >
                              <FaRedo className="OrderHistory-rebook-icon" />
                              {/* Rebook */}
                              {t("orderHistory.buttons.rebook")}
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="OrderHistory-no-orders">
                    {/* No orders yet! */}
                    {t("orderHistory.messages.noOrders")}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* Mobile Card View */}
      <div className="OrderHistory-mobile-view">
        {currentOrders.length > 0 ? (
          currentOrders.map((order) => {
            const dueDate = order.deadline || order.date || null;
            return (
              <div
                key={order.order_number}
                className="OrderHistory-mobile-card"
              >
                {/* Header: Order ID on left, Price on right */}
                <div className="OrderHistory-mobile-header">
                  <span className="OrderHistory-mobile-order-id">
                    {order.order_number}
                  </span>
                  <span className="OrderHistory-mobile-price">
                    {order.price} tk
                  </span>
                </div>

                {/* Second Row: Service on left, Status on right */}
                <div className="OrderHistory-mobile-service-status">
                  <div className="OrderHistory-mobile-service">
                    <ServiceBadge
                      service={order.Service?.services_name || "Unknown"}
                    />
                  </div>
                  <div className="OrderHistory-mobile-status">
                    <StatusBadge status={order.status} />
                  </div>
                </div>

                {/* Order Details */}
                <div className="OrderHistory-mobile-details">
                  {/* <span className="OrderHistory-mobile-details-label">
                    {t("orderHistory.tableHeaders.orderDetails")}:
                  </span> */}
                  
                  {/* <OrderDetails order={order} /> */}
                  {/* <ServiceOrderDetailsList order={order} /> */}

                  <button
                    className="OrderHistory-view-btn"
                    onClick={() => toggleDetails(order.order_number)}
                  >
                    {/* {expandedOrder === order.order_number ? "Hide Details" : "View Details"} */}
                    {expandedOrder === order.order_number ? (
                              <>
                                {/* <FaChevronUp /> Hide List */}
                                <FaChevronUp /> {t("orderHistory.hideList")}
                              </>
                            ) : (
                              <>
                                {/* <FaChevronDown /> Order List */}
                                <FaChevronDown /> {t("orderHistory.viewList")}
                              </>
                            )}
                  </button>

                  <div
                    className={`OrderHistory-details-collapse ${
                      expandedOrder === order.order_number ? "open" : ""
                    }`}
                  >
                    <OrderDetails order={order} />
                  </div>
                </div>

                {/* Countdown - Centered */}
                <div className="OrderHistory-mobile-countdown">
                  <span className="OrderHistory-mobile-countdown-label">
                    {t("orderHistory.tableHeaders.countdown")}:
                  </span>
                  <div className="OrderHistory-mobile-countdown-container">
                    <CountdownTimer dueDate={dueDate} status={order.status} />
                  </div>
                </div>

                {/* Action Buttons - Full Width */}
                <div className="OrderHistory-mobile-actions">
                  <button
                    className="OrderHistory-manage-btn"
                    onClick={() => handleManageOrder(order)}
                  >
                    {t("orderHistory.buttons.manage")}
                  </button>
                  {order.status.toLowerCase() === "completed" && (
                    <button
                      className="OrderHistory-rebook-btn"
                      onClick={() => handleRebook(order)}
                    >
                      <FaRedo className="OrderHistory-rebook-icon" />
                      {t("orderHistory.buttons.rebook")}
                    </button>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="OrderHistory-mobile-no-orders">
            {t("orderHistory.messages.noOrders")}
          </div>
        )}
      </div>

      {/* Updated Pagination */}
      <div className="OrderHistory-pagination-container">
        <span className="OrderHistory-pagination-info">
          {/* Showing {rangeStart} to {rangeEnd} out of {orders.length} */}

          {t("orderHistory.pagination.showing", {
            start: rangeStart,
            end: rangeEnd,
            total: orders.length,
          })}
        </span>
        <div className="OrderHistory-pagination-buttons">
          <Button
            color="secondary"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            {/* Previous */}
            {t("orderHistory.buttons.previous")}
          </Button>
          <Button
            color="secondary"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages || orders.length === 0}
          >
            {/* Next */}
            {t("orderHistory.buttons.next")}
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default OrderHistory;


